import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, UncontrolledTooltip, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from "moment";
import ModalImage from "react-modal-image";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
import { api } from "../../../config";
import { useReactToPrint } from "react-to-print";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import { QRCodeSVG } from "qrcode.react";
import CountUp from "react-countup";
import CurrencyInput from "react-currency-input-field";

import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";
import { useSelector, useDispatch } from "react-redux";

import { setClientSelect, setCompanySelect, setBranchSelect } from "../../../store/app/action";
import { resetLegalityAssetState, getLegalityAsset } from "../../../store/legalityAsset/action";
import { resetBudgetState, getBudget } from "../../../store/budget/action";
import { resetDepartmentState, getDepartment } from "../../../store/department/action";
import { resetLegalStatusState, getLegalStatus } from "../../../store/legalStatus/action";
import { resetLegalState, getLegal as onGetLegals, addNewLegal as onAddNewLegal, updateLegal as onUpdateLegal, deleteLegal as onDeleteLegal, getLegalLoading, resetLegalCreateState } from "../../../store/legal/action";
import { getNominatif, addNewNominatif as onAddNewNominatif, updateNominatif as onUpdateNominatif, deleteNominatif as onDeleteNominatif, resetNominatifState } from "../../../store/actions";

import ExportCSVModal from "../../../Components/Common/ExportCSVModal";
import ModalInputFile from "../../../Components/ModalInputFile";
import defaultImg from "../../../assets/images/upload.png";
//import PrintDoc from "./PrintDoc";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import ExportDoc from "../../../Components/Common/ExportDoc";
import { ButtonPrintF4, PrintDocF4 } from "./PrintDocF4";
import PrintDoc from "../../Task/PrintDoc";
import SimpleBar from "simplebar-react";

const initialValueFormik = {
  id: null,
  client: null,
  company: null,
  branch: null,
  nama: "",
  tempat_lahir: "",
  tgl_lahir: "",
  usia: "",
  pekerjaan: null,
  ktp: "",
  alamat_1: "",
  kota_pemilik: "",
  luas_tanah: "",
  kelas_desa: "",
  terbilang_luas_tanah: "",
  no_c: "",
  no_persil: "",
  blok: "",
  nop: "",
  harga: "",
  terbilang_harga: "",
  letak_tanah: "",
  desa: "",
  kecamatan: "",
  kabupaten: "",
  nama_pasangan: "",
  tanggal_lhr_pasangan: "",
  tempat_lhr_pasangan: "",
  pekerjaan_pasangan: "",
  alamat_pasangan: "",
  ktp_pasangan: "",
  tempat: "",
  tgl: "",
  rt: "",
  rw: "",
  ketua_rt: "",
  ketua_rw: "",
  kadus: "",
  sekdes: "",
  kepala_desa: "",
  utara: "",
  timur: "",
  selatan: "",
  barat: "",
  tahun_1: "",
  ats_nama_1: "",
  berdasarkan_1: "",
  tahun_2: "",
  beralih_kepada_2: "",
  berdasarkan_2: "",
  tahun_3: "",
  beralih_kepada_3: "",
  berdasarkan_3: "",
  tahun_4: "",
  beralih_kepada_4: "",
  berdasarkan_4: "",
  kota_1: "",
  kota_2: "",
  kota_3: "",
  kota_4: "",
  saksi_sk_1: "",
  umur_sk_1: "",
  pekerjaan_sk_1: "",
  alamat_sk_1: "",
  saksi_sk_2: "",
  umur_sk_2: "",
  pekerjaan_sk_2: "",
  alamat_sk_2: "",
  nama_2: "",
  usia_2: "",
  pekerjaan_2: "",
  alamat_2: "",
  no_sph: "",
  warga_negara: "",
  alih_2: "",
  saksi_st_1: "",
  njop: "",
  dasar: "",
  jenis: "",
  isCert: false,
};

const Legal = (props) => {
  const [pageIdx, setPageIdx] = useState(0);
  const [legalityDoc, setLegalityDoc] = useState([]);
  // const [legalList, setLegalList] = useState([]);
  const { t } = props;
  const printRef = useRef(null);
  const [logo, setLogo] = useState(defaultImg);
  const [modal, setModal] = useState(false);
  const [modalNominatif, setModalNominatif] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [modalHistory, setModalHistory] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeab] = useState("all");
  const [modalAccPayable, setModalAccPayable] = useState(false);
  const [indexPage, setIndexPage] = useState(0);
  const [placeValue, setPlaceValue] = useState("");
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [searchValue, setSearchValue] = useState("");

  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, legals, legalAdded,
    isLegalCreated, isLegalSuccess, loading, error, legalityAssets, legalityAssetLoading, companies, companyLoading,
    clients, clientLoading, departments, departmentLoading, branches, branchLoading, legalStatus, legalStatusLoading, nominatifs,
    nominatifLoading, isNominatifCreated, isNominatifSuccess, nominatifAdded, budgets, budgetLoading } = useSelector((state) => ({
      clientSelected: state.App.clientSelected,
      companySelected: state.App.companySelected,
      branchSelected: state.App.branchSelected,
      userData: state.App.userData,
      userRole: state.App.userRole,
      userType: state.App.userType,
      legalAdded: state.Legal.legalAdded,
      legals: state.Legal.legals,
      loading: state.Legal.loading,
      isLegalCreated: state.Legal.isLegalCreated,
      isLegalSuccess: state.Legal.isLegalSuccess,
      error: state.Legal.error,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      departments: state.Department.departments,
      departmentLoading: state.Department.loading,
      legalStatus: state.LegalStatus.legalStatus,
      legalStatusLoading: state.LegalStatus.loading,
      legalityAssets: state.LegalityAsset.legalityAssets,
      legalityAssetLoading: state.LegalityAsset.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      budgets: state.Budget.budgets,
      budgetLoading: state.Budget.loading,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      nominatifs: state.Nominatif.nominatifs,
      nominatifLoading: state.Nominatif.loading,
      isNominatifCreated: state.Nominatif.isNominatifCreated,
      isNominatifSuccess: state.Nominatif.isNominatifSuccess,
      nominatifAdded: state.Nominatif.nominatifAdded
    }));

  const [detailType, setDetailType] = useState(null);

  const [legalList, setLegalList] = useState([]);
  const [legal, setLegal] = useState([]);
  const [info, setInfo] = useState([]);
  const [assetFiles, setAssetFiles] = useState([]);
  const [profileFiles, setProfileFiles] = useState([]);
  const [detailFiles, setDetailFiles] = useState([]);

  const [isExportCSV, setIsExportCSV] = useState(false);
  const [budgetList, setBudgetList] = useState([]);
  const [departmentList, setDepartmentList] = useState([]);
  const [nominatifList, setNominatifList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [filterDate, setFilterDate] = useState();

  const [isSearch, setIsSearch] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [currentImage, setCurrentImage] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(false);

  const [departmentData, setUserData] = useState(null);
  const [legalStatusList, setLegalStatusList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [clientList, setClientList] = useState([]);

  const [modalMedia, setModalMedia] = useState(false);
  const [docImg, setDocImg] = useState([]);
  const [checkDocumentList, setCheckDocumentList] = useState([]);
  const [searchBranch, setSearchBranch] = useState("");

  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);
  //
  const [modalTrans, setModalTrans] = useState(false);
  const [expense, setExpense] = useState([]);
  const [printTransDoc, setPrintTransDoc] = useState([]);
  const expanseDataRef = useRef([]);
  //

  const searchListTrans = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return (
          (el.transaction_reff ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.transaction_no ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.supplier ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.description ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el?.at_cvl_account?.name || el?.at_cvl_contract?.cvl_contract_cvl_account?.name || (el?.at_purchase?.purchase_detail[0] && el?.at_purchase?.purchase_detail[0]?.cvl_account) || el?.at_tag?.name || "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.type ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (handleValidDate(el.transactionat) ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1 ||
          (el.branch ?? "").toLowerCase().indexOf(query.toLowerCase()) !== -1
        );
      });
    };

    let filterData = filterItems(expanseDataRef.current, inputVal);
    filterData.sort((a, b) => new Date(b.transactionat) - new Date(a.transactionat));

    setExpense(filterData);
  };

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeab(type);
      let filteredLegals = legals;
      if (type !== "all") {
        filteredLegals = legals.filter((legal) => legal.statusLegalId === type);
      }
      setLegalList(filteredLegals);
    }
  };

  const toggleNominatif = useCallback(() => {
    if (modalNominatif) {
      setModalNominatif(false);
      const { client, company, branch } = validationNom.values;
      validationNom.resetForm({
        values: {
          ...validationNom.initialValues,
          client,
          company,
          branch,
        },
      });
    } else {
      setModalNominatif(true);
      // validationNom.resetForm();
    }
  }, [modalNominatif]);

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }

  function numberToWordOnly(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final;
  }

  const pekerjaanData = [{
    options: [
      { label: "WIRASWASTA", value: "WIRASWASTA" },
      { label: "KARYAWAN SWASTA", value: "KARYAWAN SWASTA" },
      { label: "DOKTER", value: "DOKTER" },
      { label: "APARATUR SIPIL NEGARA", value: "APARATUR SIPIL NEGARA" },
      { label: "TENTARA NASIONAL INDONESIA", value: "TENTARA NASIONAL INDONESIA " },
      { label: "POLRI", value: "POLRI" },
      { label: "KARYAWAN BUMN", value: "KARYAWAN BUMN" },
      { label: "KARYAWAN BUMD", value: "KARYAWAN BUMD" },
      { label: "KARYAWAN HONORER", value: "KARYAWAN HONORER" },
      { label: "BURUH HARIAN LEPAS", value: "BURUH HARIAN LEPAS" },
      { label: "PENSIUNAN", value: "PENSIUNAN" },
      { label: "IBU RUMAH TANGGA", value: "IBU RUMAH TANGGA" },
      { label: "BELUM BEKERJA", value: "BELUM BEKERJA" },
      { label: "PELAJAR / MAHASISWA", value: "PELAJAR / MAHASISWA" },
      { label: "LAIN-LAIN", value: "LAIN-LAIN" },
      { label: "NOTARIS", value: "NOTARIS" },
      { label: "DIKOSONGKAN", value: "" },
    ],
  }];

  const blankocData = [
    {
      options: [
        { label: "SAWAH", value: "SAWAH" },
        { label: "DARAT", value: "DARAT" },
      ],
    },
  ];

  const handleNominatifClick = useCallback((row, isCopy) => {
    const data = row;

    validationNom.setValues({
      id: data.id || null,
      nama: data.nama,
      isCert: data.isCert,
      tempat_lahir: data.tempat_lahir,
      tgl_lahir: data.tgl_lahir,
      usia: data.usia,
      pekerjaan: data.pekerjaan ? { value: data.pekerjaan, label: data.pekerjaan } : null,
      blankoc: data.blankoc ? { value: data.blankoc, label: data.blankoc } : null,
      ktp: data.ktp,
      alamat_1: data.alamat_1,
      kota_pemilik: data.kota_pemilik,
      luas_tanah: data.luas_tanah,
      kelas_desa: data.kelas_desa,
      terbilang_luas_tanah: numberToWordOnly(parseFloat(data.luas_tanah), "Meter Persegi"),
      no_c: data.no_c,
      no_persil: data.no_persil,
      blok: data.blok,
      nop: data.nop,
      harga: data.harga,
      terbilang_harga: numberToWords(parseFloat(data.harga), "Rupiah"),
      letak_tanah: data.letak_tanah,
      desa: data.desa,
      kecamatan: data.kecamatan,
      kabupaten: data.kabupaten,
      nama_pasangan: data.nama_pasangan,
      tanggal_lhr_pasangan: data.tanggal_lhr_pasangan,
      tempat_lhr_pasangan: data.tempat_lhr_pasangan,
      pekerjaan_pasangan: data.pekerjaan_pasangan,
      alamat_pasangan: data.alamat_pasangan,
      ktp_pasangan: data.ktp_pasangan,
      tempat: data.tempat,
      tgl: data.tgl,
      rt: data.rt,
      rw: data.rw,
      ketua_rt: data.ketua_rt,
      ketua_rw: data.ketua_rw,
      kadus: data.kadus,
      sekdes: data.sekdes,
      kepala_desa: data.kepala_desa,
      utara: data.utara,
      timur: data.timur,
      selatan: data.selatan,
      barat: data.barat,
      tahun_1: data.tahun_1,
      ats_nama_1: data.ats_nama_1,
      tahun_2: data.tahun_2,
      beralih_kepada_2: data.beralih_kepada_2,
      berdasarkan_1: data.berdasarkan_1,
      berdasarkan_2: data.berdasarkan_2,
      tahun_3: data.tahun_3,
      beralih_kepada_3: data.beralih_kepada_3,
      berdasarkan_3: data.berdasarkan_3,
      tahun_4: data.tahun_4,
      beralih_kepada_4: data.beralih_kepada_4,
      berdasarkan_4: data.berdasarkan_4,
      kota_1: data.kota_1,
      kota_2: data.kota_2,
      kota_3: data.kota_3,
      kota_4: data.kota_4,
      saksi_sk_1: data.saksi_sk_1,
      umur_sk_1: data.umur_sk_1,
      pekerjaan_sk_1: data.pekerjaan_sk_1,
      alamat_sk_1: data.alamat_sk_1,
      saksi_sk_2: data.saksi_sk_2,
      umur_sk_2: data.umur_sk_2,
      pekerjaan_sk_2: data.pekerjaan_sk_2,
      alamat_sk_2: data.alamat_sk_2,
      nama_2: data.nama_2,
      usia_2: data.usia_2,
      pekerjaan_2: data.pekerjaan_2,
      alamat_2: data.alamat_2,
      warga_negara: data.warga_negara,
      alih_2: data.alih_2,
      saksi_st_1: data.saksi_st_1,
      njop: data.njop,
      dasar: data.dasar,
      jenis: data.jenis,
      no_sph: data.no_sph,
      no_ijin_lksi: data.no_ijin_lksi,
    });

    setIsEdit(isCopy);
    toggleNominatif();
  }, []);

  const validationSchema = (context) =>
    Yup.object({
      nama: Yup.string().required("Nama is required"),
    });

  const validationNom = useFormik({
    enableReinitialize: true,
    initialValues: initialValueFormik,
    validationSchema: validationSchema(),
    onSubmit: (values) => {
      const { id, pekerjaan, blankoc, isCert, ...tranformValue } = values;
      const dataForm = {
        clientId: clientSelected.value ?? null,
        companyId: companySelected.value ?? null,
        branchId: branchSelected.value ?? null,
        pekerjaan: values.pekerjaan?.value ?? null,
        blankoc: values.blankoc?.value ?? null,
        isCert: values.isCert ? true : false,
        ...tranformValue,
      };

      //if (isEdit) dataForm.id = values.id;
      dataForm.id = values.id;
      const action = onUpdateNominatif;
      //const action = isEdit ? onUpdateNominatif : onAddNewNominatif;

      dispatch(action(dataForm));
      toggleNominatif();
    },
  });

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    if (branchSelected) {
      handleGetLegal(companySelected?.value ?? "", branchSelected?.value ?? "");
    }
  }, [branchSelected]);

  const handleGetLegal = (id, branchId) => {
    dispatch(resetLegalState());
    dispatch(onGetLegals({ companyId: id, branchId: branchId, type: "inventory" }));

    handleGetDepartment(id);
    handleGetLegalStatus();
    handleGetNominatif(id);
    handleGetLegalityAsset(id);
    handleGetBudget(id, branchId);
  };



  useEffect(() => {
    const updatedData = legalList.map((d) => (d.nominatifId === nominatifAdded.id ? { ...d, legal_nominatif: nominatifAdded } : d));
    setLegalList(updatedData);
    dispatch(resetNominatifState());
  }, [isNominatifCreated]);

  const handleGetBudget = (companyId, branchId) => {
    dispatch(resetBudgetState());
    dispatch(getBudget({ companyId: companyId, status: 2, branchId: branchId, simple: true }));
  };

  const handleGetLegalityAsset = (id) => {
    dispatch(resetLegalityAssetState());
    dispatch(getLegalityAsset({ companyId: id }));
  };

  const handleGetDepartment = (companyId) => {
    dispatch(resetDepartmentState());
    dispatch(getDepartment({ companyId: companyId }));
  };

  const handleGetLegalStatus = () => {
    dispatch(resetLegalStatusState());
    dispatch(getLegalStatus({ type: "sph" }));
  };

  const handleGetNominatif = (companyId) => {
    dispatch(resetNominatifState());
    dispatch(getNominatif({ companyId: companyId, statusId: 2 }));
  };

  useEffect(() => {
    if (!isEmpty(legals)) {
      let filteredLegals = legals;
      if (activeTypeTab !== "all") {
        filteredLegals = legals.filter((legal) => legal.statusLegalId === activeTypeTab);
      }
      setLegalList(filteredLegals.map((el) => ({ ...el, isChecked: false })));
      const data = legals[legals.length - 1];
      if (info.id) {
        for (const obj of legals) {
          if (obj.id === info.id) {
            setInfo(obj);
            setLocationCord([obj.latitude, obj.longitude]);
          }
        }
      } else {
        setInfo(data);
        setLocationCord([data.latitude, data.longitude]);
      }
    } else {
      setLegalList([]);
      setInfo({});
    }
  }, [legals]);

  useEffect(() => {
    // let dataDoc = [
    //   {
    //     id: "name",
    //     label: "Area",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "nominatif",
    //     label: "Nomilatif",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "owner",
    //     label: "Pemilik Asal",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "quantity",
    //     label: "Luas",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "njop",
    //     label: "Harga",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "description",
    //     label: "Keterangan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_client",
    //     label: "Grup Usaha",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_company",
    //     label: "Perusahaan",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_department",
    //     label: "Departemen",
    //     isSelected: true,
    //     data: []
    //   },
    //   {
    //     id: "legal_status",
    //     label: "Status",
    //     isSelected: true,
    //     data: []
    //   },
    // ]

    let dataDoc = [
      {
        id: "code",
        label: "NO BIDANG",
        isSelected: true,
        data: [],
      },
      {
        id: "name",
        label: "LOKASI",
        isSelected: true,
        data: [],
      },
      {
        id: "owner",
        label: "NAMA",
        isSelected: true,
        data: [],
      },
      {
        id: "quantity",
        label: "LUAS UKUR",
        isSelected: true,
        data: [],
      },
      {
        id: "",
        label: "LUAS SURAT",
        isSelected: true,
        data: [],
      },
      {
        id: "njop",
        label: "HARGA / M²",
        isSelected: true,
        data: [],
      },
      {
        id: "price_other",
        label: "HARGA SPH",
        isSelected: true,
        data: [],
      },
      {
        id: "price_fee",
        label: "HARGA FEE",
        isSelected: true,
        data: [],
      },
      {
        id: "price_tax",
        label: "HARGA PAJAK TERHUTANG",
        isSelected: true,
        data: [],
      },
      {
        id: "price_pph",
        label: "HARGA PPH",
        isSelected: true,
        data: [],
      },
      {
        id: "price",
        label: "JUMLAH",
        isSelected: true,
        data: [],
      },
      {
        id: "nominal",
        label: "NOMINAL BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "sisa",
        label: "SISA BAYAR",
        isSelected: true,
        data: [],
      },
      {
        id: "sph",
        label: "SPH",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "KETERANGAN",
        isSelected: true,
        data: [],
      },
    ];

    if (legalList.length > 0) {
      legalList.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "code");
          if (doc) doc.data.push(data.code);

          doc = dataDoc.find((d) => d.id === "name");
          if (doc) doc.data.push(data.name);

          doc = dataDoc.find((d) => d.id === "owner");
          if (doc) doc.data.push(data.owner);

          doc = dataDoc.find((d) => d.id === "quantity");
          if (doc) doc.data.push(data.quantity ?? 0);

          doc = dataDoc.find((d) => d.id === "njop");
          if (doc) doc.data.push(data.njop ?? 0);

          doc = dataDoc.find((d) => d.id === "price");
          if (doc) doc.data.push(data.price ?? 0);

          doc = dataDoc.find((d) => d.id === "price_other");
          if (doc) doc.data.push(data.price_other ?? 0);

          doc = dataDoc.find((d) => d.id === "price_fee");
          if (doc) doc.data.push(data.price_fee ?? 0);

          doc = dataDoc.find((d) => d.id === "price_tax");
          if (doc) doc.data.push(data.price_tax ?? 0);

          doc = dataDoc.find((d) => d.id === "price_pph");
          if (doc) doc.data.push(data.price_pph ?? 0);

          doc = dataDoc.find((d) => d.id === "description");
          if (doc) doc.data.push(data.description);
        }
      });
    }

    setLegalityDoc(dataDoc);
  }, [legalList]);

  const reactToPrintContent = useCallback(() => {
    return printRef.current;
  }, [printRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: "Task",
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setBranchList(data);
    }
  }, [branches]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      (companies || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(budgets)) {
      var data = [];
      var opt = [{ label: "", value: "" }];
      budgets.forEach((item, key) => {
        const name = item.type + " - " + item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", undefined, { numeric: true, sensitivity: "base" })) };
      data.push(option);
      setBudgetList(data);
    } else {
      setBudgetList([]);
    }
  }, [budgets]);

  useEffect(() => {
    if (!isEmpty(departments)) {
      var data = [];
      var opt = [];
      departments.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (departments.length > 0) {
      setDepartmentList(data);
    }
  }, [departments]);

  useEffect(() => {
    if (!isEmpty(legalStatus)) {
      var data = [];
      var opt = [];
      legalStatus.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (legalStatus.length > 0) {
      setLegalStatusList(data);
    }
  }, [legalStatus]);

  useEffect(() => {
    if (!isEmpty(nominatifs)) {
      var data = [];
      var opt = [];
      nominatifs.forEach((item, key) => {
        const name = item.nama;
        const id = item.id;
        const luas_tanah = item.luas_tanah;
        const harga = item.harga;
        const nama = item.nama;
        const njop = item.njop;
        const no_c = item.no_c;
        var obj = { label: `${name}, ${luas_tanah}m2 - ${no_c}`, value: id, luas_tanah: luas_tanah, nama: nama, harga: harga, njop: njop };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
    }

    if (nominatifs.length > 0) {
      setNominatifList(data);
    }
  }, [nominatifs]);

  const onClickDelete = (legal) => {
    setLegal(legal);
    setDeleteModal(true);
  };

  const handleDeleteLegal = () => {
    if (legal) {
      dispatch(onDeleteLegal(legal));
      setDeleteModal(false);
    }
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setLegal(null);
      setAssetFiles([]);
      setDocImg([]);
      validation.resetForm();
    } else {
      setModal(true);
    }
  }, [modal]);

  const toggleTrans = useCallback(() => {
    if (modalTrans) {
      setModalTrans(false);
    } else {
      setModalTrans(true);
    }
  }, [modalTrans]);

  const toggleAccPayable = useCallback(() => {
    if (modalAccPayable) {
      setModalAccPayable(false);
    } else {
      setModalAccPayable(true);
    }
  }, [modalAccPayable]);

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleHistory = useCallback(() => {
    if (modalHistory) {
      setModalHistory(false);
    } else {
      setModalHistory(true);
    }
  }, [modalHistory]);

  const toggleDetail = useCallback(
    (type) => {
      if (modalDetail) {
        setModalDetail(false);
        setDetailType(null);
      } else {
        setModalDetail(true);
        setDetailType(type);
      }
    },
    [modalDetail]
  );

  const handleLegalClick = useCallback(
    (arg, type) => {
      const data = arg;

      handleGetDepartment(data.companyId);
      handleGetNominatif(data.companyId);

      let legalDetail = [];
      if (data.legal_detail) {
        for (const element of data.legal_detail) {
          legalDetail.push({
            detailId: element.id,
            filename: element.filename,
            originalname: element.originalname,
            description: element.description,
          });
        }
      }
      setDetailFiles(legalDetail);

      let legalProfile = [];
      if (data.legal_profile) {
        for (const element of data.legal_profile) {
          legalProfile.push({
            detailId: element.id,
            filename: element.filename,
            originalname: element.originalname,
            description: element.description,
          });
        }
      }
      setProfileFiles(legalProfile);

      let arrLegal = [];
      if (data.legality && data.legality.length > 0) {
        for (const d of data.legality) {
          arrLegal.push(d);
        }
      } else {
        for (const d of legalityAssets) arrLegal.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
      }
      setCheckDocumentList(arrLegal);
      data.legality = arrLegal;

      let address_legal = {};
      for (const address of data.legal_address) {
        if (address.isPrimary) {
          address_legal = address;
        }
      }

      let files = [];
      for (const f of data.legal_file) {
        files.push({ filename: f.filename, originalname: f.originalname });
      }
      setAssetFiles(files);

      setLegal({
        id: data.id,
        companyId: data.companyId,
        clientId: data.clientId,
        description: data.description,
        street: address_legal.description ?? "",
        sph: data.sph ?? "",
        departmentId: data.departmentId,
        quantity: parseFloat(data.quantity),
        quantity_real: parseFloat(data.quantity_real),
        njop: parseFloat(data?.njop) || 0,
        price: parseFloat(data?.price) || 0,
        price_other: parseFloat(data?.price_other) || 0,
        name: data.name,
        code: data.code,
        //nominatif: data.legal_nominatif && { label: `${data.legal_nominatif.nama}, ${data.legal_nominatif.luas_tanah}m2 - ${data.legal_nominatif.no_c}`, value: data.legal_nominatif.id, harga: data?.legal_nominatif?.harga, njop: data?.legal_nominatif?.njop },
        nominatif: data?.nominatif || data?.legal_nominatif?.nama,
        owner: data?.legal_nominatif?.nama,
        pic: data.pic,
        latitude: data.latitude,
        longitude: data.longitude,
        price_pph: data.price_pph,
        price_tax: data.price_tax,
        price_fee: data.price_fee,
        branch: data.legal_branch && { label: data.legal_branch.name, value: data.legal_branch.id },
        company: data.legal_company && { label: data.legal_company.name, value: data.legal_company.id },
        client: data.legal_client && { label: data.legal_client.name, value: data.legal_client.id },
        department: data.legal_department && {
          label: data.legal_department.name,
          value: data.legal_department.id,
        },
        legal_status_legal: data.legal_status_legal && {
          label: data.legal_status_legal.name,
          value: data.legal_status_legal.id,
        },
        details: legalDetail,
        profiles: legalProfile,
        legality: data.legality,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, legalityAssets]
  );

  const handleSalesClick = useCallback(
    (type) => {
      toggleDetail(type);
    },
    [toggleDetail, userType]
  );

  const [isCheckAll, setIsCheckAll] = useState(false);
  const rowsRef = useRef([]);
  const checkedAll = () => {
    const allChecked = rowsRef.current.every((item) => item?.isChecked);
    const visibleIds = rowsRef.current.map((r) => String(r.id));

    const updated = legalList.map((item) => {
      const isVisible = visibleIds.includes(String(item.id));
      return isVisible ? { ...item, isChecked: !allChecked } : item;
    });
    setLegalList(updated);
    setIsCheckAll(allChecked);
  };

  const [isButtonPrint, setIsButtonPrint] = useState(false);
  useEffect(() => {
    const hasChecked = legalList.some((item) => item.isChecked);
    setIsButtonPrint(hasChecked);
  }, [legalList]);

  const columns = useMemo(() => [{
    Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" checked={isCheckAll} onChange={checkedAll} />,
    Cell: (cellProps) => {
      let data = cellProps.row.original;
      let price = parseFloat(data.price || 0);
      let amount = (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);

      return (
        <div className="hstack gap-2 mt-4 mt-sm-0">
          <input
            type="checkbox"
            className="dataCheckbox me-2 form-check-input"
            checked={legalList.find((x) => x.id === data.id).isChecked}
            onChange={() => {
              const updatedData = legalList.map((d) => (d.id === data.id ? { ...d, isChecked: !d.isChecked } : d));
              setLegalList(updatedData);
            }}
          />
          <ButtonGroup className="me-1">
            <UncontrolledButtonDropdown>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  setInfo(data);
                  // handleSalesClick(data);
                  handleNominatifClick(data.legal_nominatif);
                }}>
                <i className="ri-newspaper-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  handleLegalClick(data);
                }}>
                <i className="ri-edit-2-line fs-15"></i>
              </Button>
              <Button
                color="light"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteLegal") !== -1 ? "btn-sm" : "btn-sm d-none"}
                onClick={() => {
                  data.statusId = 3;
                  onClickDelete(data);
                }}>
                <i className="ri-delete-bin-line fs-15 text-danger"></i>
              </Button>
              <DropdownToggle tag="button" className={userType === "admin" || userType === "client" ? "btn btn-sm btn-light" : userRole && userRole.split(",").indexOf("updateLegal") !== -1 ? "btn btn-sm btn-light" : "btn btn-sm btn-light d-none"} split></DropdownToggle>
              <DropdownMenu>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-tidak-sengketa");
                  }}
                >
                  PRINT SURAT PERNYATAAN TIDAK SENGKETA
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-menghadap");
                  }}
                >
                  PRINT SURAT PERNYATAAN MENGHADAP
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan-status-tanah");
                  }}
                >
                  PRINT SURAT KETERANGAN STATUS TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan-riwayat-tanah");
                  }}
                >
                  PRINT SURAT KETERANGAN RIWAYAT TANAH
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-pernyataan-menjual");
                  }}
                >
                  PRINT SURAT PERNYATAAN MENJUAL
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-keterangan");
                  }}
                >
                  PRINT SURAT KETERANGAN
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-tabel");
                  }}
                >
                  PRINT BLANKO C
                </DropdownItem>
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-persetujuan-pasangan-atau-anak");
                  }}
                >
                  PRINT SURAT PERSETUJUAN PASANGAN ATAU ANAK
                </DropdownItem>
                {/* <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("f4-surat-persetujuan-anak");
                  }}>
                  PRINT SURAT PERSETUJUAN ANAK
                </DropdownItem> */}
                <DropdownItem
                  onClick={() => {
                    setInfo(data);
                    handleSalesClick("a3-sph");
                  }}
                >
                  PRINT SURAT PERNYATAAN PELEPASAN HAK ATAS TANAH UNTUK KEPENTINGAN SWASTA
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={() => {
                    data.statusId = 3;
                    onClickDelete(data);
                  }}
                >HAPUS
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledButtonDropdown>
            <button
              className={"btn me-2 btn-sm btn-soft-info"}
              onClick={() => {
                setInfo(data);
                toggleAccPayable();
              }}
            >
              <i className="ri-file-list-3-line fs-12 label-icon align-middle me-1"></i> INVOICE
            </button>
          </ButtonGroup>
        </div>
      );
    },
    id: "#",
  },
  {
    Header: "Nama",
    accessor: (data) => data?.nominatif || data?.legal_nominatif?.nama,
    filterable: true,
    Cell: (cellProps) => {
      const data = cellProps.row.original;
      let status;
      switch (data?.legal_status?.name) {
        case "DRAFT":
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_status?.name} </span>;
          break;
        case "ACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-info"> {data?.legal_status?.name} </span>;
          break;
        case "INACTIVE":
          status = <span className="badge fs-10 text-uppercase badge-soft-danger"> {data?.legal_status?.name} </span>;
          break;
        default:
          status = <span className="badge fs-10 text-uppercase badge-soft-warning"> {data?.legal_status?.name} </span>;
          break;
      }
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            setInfo(data);
            setLocationCord([data.latitude, data.longitude]);
          }}
        >
          <div className="mb-1">{data?.nominatif || data?.legal_nominatif?.nama || "NO NAME"}</div>
          <div className="hstack gap-2">
            <span className="badge fw-normal fs-9" style={{ backgroundColor: data?.legal_status_legal?.color, color: "#555  " }}>
              {data?.legal_status_legal?.name}
            </span>
            <span className="badge fw-normal text-dark fs-9 bg-soft-info">{data?.name}</span>
            {status}
          </div>
        </div>
      );
    },
  },
  {
    Header: "No Bid",
    accessor: "code",
    filterable: true,
  },
  {
    id: "size",
    Header: "Luas",
    accessor: "quantity",
    filterable: true,
    Cell: (data) => (
      <span>
        {currencyFormat(data.value ? data.value : 0)} m<sup>2</sup>
      </span>
    ),
  },
  {
    id: "njop",
    Header: "Harga",
    accessor: "njop",
    filterable: true,
    Cell: (data) => <span>{currencyFormat(data.row.original?.njop || 0)}</span>,
  },
  {
    id: "price",
    Header: "Harga Tanah",
    accessor: (data) => ((data.price || 0) + (data.price_other || 0) + (data.price_fee || 0) + (data.price_tax || 0) + (data.price_pph || 0)),
    filterable: true,
    Cell: (data) => <span>{currencyFormat(data?.value || 0)}</span>,
  },
  {
    id: "haspaid",
    Header: "haspaid",
    accessor: (data) => data.price <= (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) ? data.quantity : 0,
    filterable: true,
  },

  {
    id: "unpaid",
    Header: "unpaid",
    accessor: (data) => data.price > (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0) ? data.quantity : 0,
    filterable: true,
  },
  {
    id: "price_other",
    Header: "Harga SPH",
    accessor: "price_other",
    filterable: true,
    Cell: (data) => <span>{currencyFormat(data.row.original?.price_other || 0)}</span>,
  },
  {
    id: "payable",
    Header: "Terhutang",
    accessor: (data) => (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      return (
        <div>
          <span
            onClick={() => {
              const dataRow = data.row.original;
              expanseDataRef.current = dataRow.legal_trans || [];
              setInfo(dataRow);
              setExpense(dataRow.legal_trans || []);
              toggleTrans();
            }}
            className="fw-semibold text-info cursor-pointer"
          >
            {currencyFormat(data.value)}
          </span>
        </div>
      );
    },
  },
  {
    id: "paid",
    Header: "Terbayar",
    accessor: (data) => (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      let price = (data.row.original.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "PAYABLE").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      let amount = (data.row.original.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0);
      return (
        <div>
          <span
            onClick={() => {
              const dataRow = data.row.original;
              expanseDataRef.current = dataRow.legal_trans || [];
              setInfo(dataRow);
              setExpense(dataRow.legal_trans || []);
              toggleTrans();
            }}
            className={amount >= price ? "fw-semibold text-success cursor-pointer" : amount > 0 && amount < price ? "fw-semibold text-warning cursor-pointer" : "fw-semibold text-danger cursor-pointer"}>
            {currencyFormat(data.value)}
          </span>
        </div>
      );
    },
  },
  {
    id: "paid_left",
    Header: "Sisa Bayar",
    accessor: (data) => ((data.price || 0) + (data.price_other || 0) + (data.price_fee || 0) + (data.price_tax || 0) + (data.price_pph || 0)) - (data.legal_trans || []).filter((element) => (element.statusId === 3) && element.type === "CASH OUT").reduce((a, v) => (a = a + parseFloat(v.amount || 0)), 0),
    filterable: true,
    Cell: (data) => {
      return (
        <div>
          <span
            onClick={() => {
              const dataRow = data.row.original;
              expanseDataRef.current = dataRow.legal_trans || [];
              setInfo(dataRow);
              setExpense(dataRow.legal_trans || []);
              toggleTrans();
            }}
            className="fw-semibold text-danger cursor-pointer"
          >
            {currencyFormat(data.value)}
          </span>
        </div>
      );
    },
  },
  {
    id: "Area",
    Header: "Area",
    accessor: "name",
    filterable: true,
  },
  // {
  //   Header: "Tgl Input",
  //   accessor: "createdat",
  //   filterable: true,
  //   Cell: (data) => {
  //     return handleValidDate(data.row.original.createdat);
  //   },
  // },
  // {
  //   id: "Department",
  //   Header: "Departemen",
  //   accessor: "legal_department.name",
  //   filterable: true,
  //   Cell: (data) => <span className="fw-semibold">{data.row.original.pic && `${data.row.original.pic} / `}{data.value}</span>
  // },
  {
    id: "Status",
    Header: "Status",
    accessor: "legal_status_legal.name",
    filterable: true,
  },
  ],
    [legalList, handleLegalClick, toggleHistory, userRole, userType, isCheckAll]
  );

  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onChange = useAsyncDebounce((value) => {
    const resetChecked = legalList.map((item) => ({
      ...item,
      isChecked: false,
    }));
    setLegalList(resetChecked);
    setIsCheckAll(false);
    setGlobalFilter(value || undefined);
    setGlobalFilterValue(value ?? "");
  }, 300);

  const memoizedData = useMemo(() => legalList, [legalList]);

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: memoizedData,
      defaultColumn: { Filter: null },
      initialState: {
        hiddenColumns: ["Department", "Status", "Area", "haspaid", "unpaid", "price_other"],
        pageIndex: pageIdx,
        pageSize: 10,
        selectedRowIds: 0,
        globalFilter: globalFilterValue,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  useEffect(() => {
    const currentRows = rows.map((r) => r.original);
    rowsRef.current = currentRows;
    const allChecked = currentRows.length > 0 && currentRows.every((item) => item.isChecked);
    setIsCheckAll(allChecked);
  }, [rows]);

  useEffect(() => {
    setIndexPage(pageIndex);
  }, [pageIndex]);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    setPageIdx(page);
    gotoPage(page);
  };

  const countSearch = preGlobalFilteredRows.length;

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      type: "inventory",
      branchId: branchSelected?.value ?? "",
    };
    dispatch(onGetLegals(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setLegalList([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    setGlobalFilterValue("");
    handleGetLegal(companySelected?.value ?? "", branchSelected?.value ?? "");
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteLegal(element.value));
    });
    checkall.checked = false;
  };

  function handleLegalDetailAdd(type) {
    if (type === "profile") setProfileFiles([...profileFiles, { filename: "", originalname: "", description: "" }]);
    else setDetailFiles([...detailFiles, { filename: "", originalname: "", description: "" }]);
  }

  const handleSelectFile = (file) => {
    if (currentImage === "detail") {
      detailFiles[currentImageIndex].filename = file.filename;
      detailFiles[currentImageIndex].originalname = file.originalname;
    } else if (currentImage === "profile") {
      profileFiles[currentImageIndex].filename = file.filename;
      profileFiles[currentImageIndex].originalname = file.originalname;
    } else {
      setAssetFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    }
    setCurrentImage(null);
    setCurrentImageIndex(null);
    toggleMedia();
  };

  useEffect(() => {
    let dataDoc = [
      {
        id: "transaction_no",
        label: "No Transaksi",
        isSelected: true,
        data: [],
      },
      {
        id: "transactionat",
        label: "Tanggal",
        isSelected: true,
        data: [],
      },
      {
        id: "type",
        label: "Jenis",
        isSelected: true,
        data: [],
      },
      {
        id: "tag",
        label: "Tag",
        isSelected: true,
        data: [],
      },
      {
        id: "amount",
        label: "Jumlah Pembayaran",
        isSelected: true,
        data: [],
      },
      {
        id: "description",
        label: "Keterangan",
        isSelected: true,
        data: [],
      },
    ];

    if (expense.length > 0) {
      expense.forEach((data) => {
        if (data.isChecked) {
          let doc = dataDoc.find((d) => d.id === "tag");
          doc.data.push(data?.at_cvl_account?.name || data?.at_legal?.owner || data?.at_cvl_contract?.cvl_contract_cvl_account?.name || (data?.at_purchase?.purchase_detail[0] && data?.at_purchase?.purchase_detail[0]?.cvl_account) || data?.at_tag?.name);

          doc = dataDoc.find((d) => d.id === "transaction_no");
          doc.data.push(data?.transaction_no);

          doc = dataDoc.find((d) => d.id === "transactionat");
          doc.data.push(handleValidDate(data?.transactionat));

          doc = dataDoc.find((d) => d.id === "type");
          doc.data.push(data?.type);

          doc = dataDoc.find((d) => d.id === "amount");
          doc.data.push(Math.round(data?.amount));

          doc = dataDoc.find((d) => d.id === "description");
          doc.data.push(data?.description);
        }
      });
    }

    setPrintTransDoc(dataDoc);
  }, [expense]);

  const renderIcon = (fileName) => {
    const type = fileName.split(".");
    switch (type[type.length - 1]) {
      case "sheet":
        return <i className="ri-file-excel-line me-1 align-bottom text-success"></i>;
      case "x-compressed":
        return <i className="ri-file-zip-line me-1 align-bottom text-danger"></i>;
      case "pdf":
        return <i className="ri-file-pdf-line me-1 align-bottom text-danger"></i>;
      default:
        return <ModalImage showRotate={true} small={`${api.MEDIA_URL}/media/${fileName}-w-50`} large={`${api.MEDIA_URL}/media/${fileName}`} alt={info.name} className="img-thumbnail avatar-xs img-thumbnail user-profile-image" />;
    }
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: (legal && legal.id) || 0,
      company: (legal && legal.company) || companySelected,
      client: (legal && legal.client) || clientSelected,
      branch: (legal && legal.branch) || branchSelected,
      name: (legal && legal.name) ?? "",
      nominatif: (legal && legal.nominatif) ?? "",
      code: (legal && legal.code) ?? "",
      owner: (legal && legal.owner) ?? "",
      street: (legal && legal.street) ?? "",
      legal_status_legal: (legal && legal.legal_status_legal) ?? "",
      sph: (legal && legal.sph) ?? "",
      pic: (legal && legal.pic) ?? "",
      longitude: (legal && legal.longitude) ?? "",
      latitude: (legal && legal.latitude) ?? "",
      quantity: (legal && legal.quantity) || 0,
      quantity_real: (legal && legal.quantity_real) || 0,
      njop: (legal && legal.njop) || 0,
      price: (legal && legal.price) || 0,
      price_pph: (legal && legal.price_pph) || 0,
      price_tax: (legal && legal.price_tax) || 0,
      price_fee: (legal && legal.price_fee) || 0,
      price_other: (legal && legal.price_other) || 0,
      description: (legal && legal.description) ?? "",
      department: (legal && legal.department) ?? "",
      profiles: (legal && legal.profiles) ?? "",
      details: (legal && legal.details) ?? "",
      legality: (legal && legal.legality) || [],
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Isi Nama Bidang"),
      nominatif: Yup.string().required("Isi Nama Nominatif"),
      //owner: Yup.string().required("Isi Nama Pemilk Asal"),
      company: Yup.object().required("Please Select company").nullable(true),
      client: Yup.object().required("Silahkan isi grup perusahaan").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalLoading());
      if (isEdit) {
        let editSubmit = {
          type: "inventory",
          id: values.id,
          name: values.name,
          nominatif: values.nominatif,
          //nominatifId: values.nominatif.value,
          code: values.code,
          owner: values.nominatif,
          pic: values.pic,
          description: values.description,
          street: values.street,
          sph: values.sph,
          statusLegalId: values.legal_status_legal.value,
          departmentId: values.department.value,
          longitude: values.longitude,
          latitude: values.latitude,
          quantity: values.quantity,
          quantity_real: values.quantity_real,
          njop: values.njop,
          price: values.price,
          price_pph: values.price_pph,
          price_tax: values.price_tax,
          price_fee: values.price_fee,
          price_other: values.price_other,
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          legal_profile: JSON.stringify(profileFiles),
          legal_detail: JSON.stringify(detailFiles),
          files: assetFiles.length > 0 ? assetFiles : [],
          legality: values.legality,
        };
        dispatch(onUpdateLegal(editSubmit));
      } else {
        let addSubmit = {
          type: "inventory",
          name: values.name,
          nominatif: values.nominatif,
          //nominatifId: values.nominatif.value,
          code: values.code,
          owner: values.nominatif,
          pic: values.pic,
          sph: values.sph,
          description: values.description,
          statusLegalId: values.legal_status_legal.value,
          departmentId: values.department.value,
          longitude: values.longitude,
          latitude: values.latitude,
          quantity: values.quantity,
          quantity_real: values.quantity_real,
          njop: values.njop,
          price: values.price,
          price_pph: values.price_pph,
          price_tax: values.price_tax,
          price_fee: values.price_fee,
          price_other: values.price_other,
          branchId: values.branch.value,
          clientId: values.client.value,
          companyId: values.company.value,
          legal_profile: JSON.stringify(profileFiles),
          legal_detail: JSON.stringify(detailFiles),
          files: assetFiles.length > 0 ? assetFiles : [],
          legality: values.legality,
        };
        dispatch(onAddNewLegal(addSubmit));
      }
      validation.resetForm();
      toggle();
    },
  });

  const validationAccPayable = useFormik({
    enableReinitialize: true,
    initialValues: {
      amount: 0,
      account: "",
      cashflow: "",
      description: `TANAH DALAM PENGEMBANGAN ${info?.legal_nominatif?.nama + " - " + info?.name}`,
      transactionat: moment().format("YYYY/MM/DD"),
    },
    validationSchema: Yup.object({
      amount: Yup.string().required("Please Pick Amount"),
      cashflow: Yup.object().required("Silahkan isi Anggaran Cashflow").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getLegalLoading());
      info.setAccPayable = true;
      info.setApprove = false;
      info.transactionat = values.transactionat;
      info.budgetId = values.cashflow.value;
      info.accType = "PAYABLE";
      info.description = values.description;
      info.amount = values.amount;
      dispatch(onUpdateLegal(info));
      validationAccPayable.resetForm();
      toggleAccPayable();
    },
  });

  const onClickDeleteDetailItem = (filename, type) => {
    if (type === "profile") {
      const index = profileFiles.findIndex((fl) => fl.filename === filename);
      setProfileFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    } else {
      const index = detailFiles.findIndex((fl) => fl.filename === filename);
      setDetailFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = assetFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setAssetFiles(newState);
    } else {
      const index = assetFiles.findIndex((fl) => fl.filename === file.filename);
      setAssetFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  document.title = "Pelepasan Hak (SPH) | Enterprise Resources Planning";

  return (
    <>
      <div className="page-content">
        <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={legalList} />
        <DeleteModal show={deleteModal} onDeleteClick={handleDeleteLegal} onCloseClick={() => setDeleteModal(false)} />
        <DeleteModal
          show={deleteModalMulti}
          onDeleteClick={() => {
            deleteMultiple();
            setDeleteModalMulti(false);
          }}
          onCloseClick={() => setDeleteModalMulti(false)}
        />
        <Container fluid>
          <BreadCrumb title="Pertanahan" pageTitle="Pelepasan Hak (SPH)" loading={loading}>
            <div className="flex-shrink-0">
              <button
                type="button"
                className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-primary add-btn me-2" : userRole && userRole.split(",").indexOf("createLegal") !== -1 ? "btn btn-primary add-btn me-2" : "d-none"}
                id="create-btn"
                onClick={() => {
                  setIsEdit(false);
                  let arrLegal = [];
                  for (const d of legalityAssets) arrLegal.push({ id: 0, name: d.name, targetat: "", actualat: "", description: "" });
                  setCheckDocumentList(arrLegal);
                  validation.setFieldValue("legality", arrLegal);
                  toggle();
                }}
              >
                <i className="ri-archive-line me-1 align-bottom fs-14"></i> Tambah
              </button>
              <ExportDoc data={legalityDoc} />
            </div>
          </BreadCrumb>
          <Row>
            <Col sm={12}>
              <div className="hstack gap-3">
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={rows.reduce((a, v) => (a = a + parseFloat(v.values.size || 0)), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Pembebasan Tanah</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={rows.reduce((a, v) => (a = a + parseFloat(v.values.haspaid || 0)), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Dibebaskan</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="" suffix={" M²"} separator="." end={rows.reduce((a, v) => (a = a + parseFloat(v.values.unpaid || 0)), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Belum Dibebaskan</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={rows.reduce((a, v) => (a = a + parseFloat((v.values.price || 0) + (v.values.price || 0) + (v.values.price_other || 0) + (v.values.price_fee || 0) + (v.values.price_tax || 0) + (v.values.price_pph || 0))), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Estimasi Harga Tanah</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={rows.reduce((a, v) => (a = a + parseFloat(v.values.paid || 0)), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Tanah Terbayar</div>
                </div>
                <div className="card align-items-center card-animate p-3" style={{ width: 100 / 5 + "%", minHeight: "30px", verticalAlign: "middle" }}>
                  <div className="fs-17 fw-semibold">
                    <CountUp start={0} prefix="Rp" suffix={""} separator="." end={rows.reduce((a, v) => (a = a + parseFloat(v.values.paid_left || 0)), 0)} decimals={0} duration={2} />
                  </div>
                  <div className="col-auto fs-12 text-center text-muted flex-grow-1">Menunggu Pembayaran</div>
                </div>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody className="pt-1 pb-0">
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist">
                    <NavItem>
                      <NavLink
                        className={classnames({ active: activeTab === "1" }, "fw-semibold")}
                        onClick={() => {
                          toggleTab("1", "all");
                        }}
                        href="#"
                      >
                        <i className="ri-file-list-3-line me-1 align-bottom fs-14"></i> SEMUA PELEPASAN HAK (SPH)
                      </NavLink>
                    </NavItem>
                    {legalStatus.map((o, i) => (
                      <NavItem key={i}>
                        <NavLink
                          className={classnames({ active: activeTab === i + 2 }, "fw-semibold")}
                          onClick={() => {
                            toggleTab(i + 2, o.id);
                          }}
                          href="#"
                        >
                          <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i> {o.name}
                        </NavLink>
                      </NavItem>
                    ))}
                  </Nav>
                  <Row className="mb-0">
                    <CardBody className="pb-0">
                      <Row>
                        <Col sm={1}>
                          <div className="me-2 mb-3 col-12">
                            <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                              {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>
                                  {pageSize}
                                </option>
                              ))}
                            </select>
                          </div>
                        </Col>
                        <Col sm={9}>
                          <div className="search-box me-2 mb-3 d-inline-block col-12">
                            <input
                              id="search-bar-0"
                              type="text"
                              className="form-control search"
                              onChange={(e) => {
                                setLegalList(legals.map((el) => ({ ...el, isChecked: false })));
                                setSearchValue(e.target.value);
                                onChange(e.target.value);
                                gotoPage(0);
                              }}
                              placeholder={`${countSearch} Cari...`}
                              value={searchValue ?? ""}
                            />
                            <i className="bx bx-search-alt search-icon"></i>
                          </div>
                        </Col>
                        <Col sm={2}>
                          <div className="hstack gap-2">
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleFilter();
                              }}
                            >
                              <i className="ri-search-line align-bottom fs-16"></i>
                            </button>
                            <button
                              type="button"
                              className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                              onClick={() => {
                                handleResetFilter();
                              }}
                            >
                              <i className="mdi mdi-restore align-bottom fs-18"></i>
                            </button>
                          </div>
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                </CardBody>
              </Card>
            </Col>
            <Col lg={9} style={{ position: "relative" }}>
              <Card style={{ position: "sticky", top: "94px" }}>
                <CardBody>
                  <div>
                    <div className="table-responsive table-card mb-1" style={{ minHeight: "380px" }}>
                      <Table hover {...getTableProps()} className="align-middle table-nowrap">
                        <thead className="table-info">
                          {headerGroups.map((headerGroup, index) => (
                            <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                              {headerGroup.headers.map((column, index) => (
                                <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                  {column.render("Header")}
                                  {generateSortingIndicator(column)}
                                  {/* <Filter column={column} /> */}
                                </th>
                              ))}
                            </tr>
                          ))}
                        </thead>
                        <tbody {...getTableBodyProps()}>
                          <tr className="bg-light">
                            <th colSpan={5}>
                              {isButtonPrint && (
                                <div className="fw-semibold">
                                  TOTAL Rp {currencyFormat(rows.filter(f => f.original.isChecked).reduce((a, v) => (a = a + parseFloat((v.values.price || 0) + (v.values.price_other || 0) + (v.values.price_fee || 0) + (v.values.price_tax || 0) + (v.values.price_pph || 0))), 0))} (
                                  {currencyFormat(rows.filter(f => f.original.isChecked).reduce((a, v) => (a = a + parseFloat(v.values.size || 0)), 0))} m<sup>2</sup>)
                                </div>
                              )}
                            </th>
                            <th className="text-info fs-13">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat((v.values.price || 0) + (v.values.price_other || 0) + (v.values.price_fee || 0) + (v.values.price_tax || 0) + (v.values.price_pph || 0))), 0))}</th>
                            <th className="text-info fs-13">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.payable || 0)), 0))}</th>
                            <th className="text-info fs-13">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.paid || 0)), 0))}</th>
                            <th className="text-info fs-13">{currencyFormat(rows.reduce((a, v) => (a = a + parseFloat(v.values.paid_left || 0)), 0))}</th>
                          </tr>
                          {page.map((row) => {
                            prepareRow(row);
                            return (
                              <Fragment key={row.getRowProps().key}>
                                <tr>
                                  {row.cells.map((cell, index) => {
                                    return (
                                      <td {...cell.getCellProps()} key={index}>
                                        {cell.render("Cell")}
                                      </td>
                                    );
                                  })}
                                </tr>
                              </Fragment>
                            );
                          })}
                        </tbody>
                      </Table>
                    </div>

                    <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                      <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex - 1);
                              previousPage();
                            }}
                            disabled={!canPreviousPage}
                          >
                            {"<"}
                          </Button>
                        </div>
                      </Col>
                      <Col className="col-md-auto d-none d-md-block">
                        Halaman {pageIndex + 1} dari {pageOptions.length}
                      </Col>
                      <Col className="col-md-auto">
                        <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                      </Col>
                      <Col className="col-md-auto">
                        <div className="d-flex gap-1">
                          <Button
                            className="btn btn-light"
                            onClick={() => {
                              setPageIdx(pageIndex + 1);
                              nextPage();
                            }}
                            disabled={!canNextPage}
                          >
                            {">"}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <Modal id="showModal" isOpen={modal} centered size="xl">
                    <ModalHeader className="bg-light p-3" toggle={toggle}>
                      {!!isEdit ? "Edit Aset Legalitas" : "Tambah Aset Legalitas"}
                    </ModalHeader>
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        validation.handleSubmit();
                        return false;
                      }}
                    >
                      <ModalBody>
                        <CardBody className="border-bottom p-3 pt-0 pb-0 border-bottom-dashed">
                          <Row>
                            <Col lg={5}>

                              <div className="mb-3">
                                <Label htmlFor="address-field" className="form-label">
                                  {t("Cabang / Proyek")}
                                </Label>
                                <Select
                                  name="branch"
                                  value={validation.values.branch}
                                  placeholder="Pilih Proyek"
                                  onChange={(e) => {
                                    dispatch(setBranchSelect(e));
                                    validation.setFieldValue("branch", e);
                                  }}
                                  options={branchList}
                                ></Select>
                              </div>
                              {/* ////nominatif//// */}
                              <div className="mb-3">
                                <Label htmlFor="name-field" className="form-label">
                                  {t("Area")}
                                </Label>
                                <Input name="name" id="name-field" className="form-control" placeholder="Isi Area Bidang" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.name ?? ""} invalid={validation.touched.name && validation.errors.name ? true : false} />
                                {validation.touched.name && validation.errors.name && <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>}
                              </div>
                              <div className="mb-3">
                                <Label htmlFor="nominatif-field" className="form-label">
                                  {t("Nama")}
                                </Label>
                                <Input name="nominatif" id="nominatif-field" className="form-control" placeholder="Isi Nama Bidang" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.nominatif ?? ""} invalid={validation.touched.nominatif && validation.errors.nominatif ? true : false} />
                                {validation.touched.nominatif && validation.errors.nominatif && <FormFeedback type="invalid">{validation.errors.nominatif}</FormFeedback>}
                              </div>
                              {/* <div className="mb-3">
                                <Label htmlFor="nominatif-field" className="form-label">
                                  Nominatif
                                </Label>
                                <div className="position-relative">
                                  <Select
                                    name="nominatif"
                                    value={validation.values.nominatif}
                                    placeholder="Pilih Nominatif"
                                    onChange={(e) => {
                                      validation.setFieldValue("nominatif", e);
                                      validation.setFieldValue("owner", e.nama);
                                      validation.setFieldValue("quantity", parseFloat(e.luas_tanah));
                                      validation.setFieldValue("quantity_real", parseFloat(e.luas_tanah));
                                      validation.setFieldValue("price", parseFloat(e.harga));
                                      validation.setFieldValue("njop", parseFloat(e.njop));
                                    }}
                                    options={nominatifList}
                                  ></Select>
                                  <div
                                    className="position-absolute"
                                    style={{
                                      top: "12px",
                                      left: "-24px",
                                    }}
                                  >
                                    {nominatifLoading && (
                                      <Spinner color="primary" size="sm">
                                        Loading...
                                      </Spinner>
                                    )}
                                  </div>
                                </div>
                                {validation.touched.nominatif && validation.errors.nominatif && (
                                  <p className="invalid-feedback d-block" type="invalid">
                                    {validation.errors.nominatif}
                                  </p>
                                )}
                              </div> */}
                              {/* <div className='mb-3'>
                              <Label htmlFor='nominatif-field' className='form-label'>{t("Nominatif")}</Label>
                              <Input name='nominatif' id='nominatif-field' className='form-control' placeholder='Isi Kode Bidang' type='text'
                                validate={{ required: { value: true } }}
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.nominatif ?? ""}
                                invalid={validation.touched.nominatif && validation.errors.nominatif ? true : false} />
                              {validation.touched.nominatif && validation.errors.nominatif && (
                                <FormFeedback type='invalid'>{validation.errors.nominatif}</FormFeedback>
                              )}
                            </div> */}

                              <div className="mb-3">
                                <Label htmlFor="code-field" className="form-label">
                                  {t("Kode Bidang")}
                                </Label>
                                <Input name="code" id="code-field" className="form-control" placeholder="Isi Nomor Bidang" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.code ?? ""} invalid={validation.touched.code && validation.errors.code ? true : false} />
                                {validation.touched.code && validation.errors.code && <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>}
                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="owner-field" className="form-label">
                                  {t("Pemilik Asal")}
                                </Label>
                                <Input name="owner" id="owner-field" className="form-control" placeholder="Isi Nama Pemilik Asal" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.owner ?? ""} invalid={validation.touched.owner && validation.errors.owner ? true : false} />
                                {validation.touched.owner && validation.errors.owner && <FormFeedback type="invalid">{validation.errors.owner}</FormFeedback>}
                              </div>
                              <div className="mb-3 col-lg-12 d-none">
                                <Label htmlFor="sph-field" className="form-label">
                                  {t("No SPH")}
                                </Label>
                                <Input name="sph" id="sph-field" className="form-control" placeholder="Isi No SPH" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.sph} />
                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="des-field" className="form-label">
                                  {t("Keterangan")}
                                </Label>
                                <Input name="address" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.address ?? ""} />
                              </div>
                              <div className="row">
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="quantity-field" className="form-label">
                                    {t("Luas Surat")}
                                  </Label>
                                  <Input
                                    name="quantity"
                                    id="quantity-field"
                                    className="form-control"
                                    placeholder="Isi Luas Tanah"
                                    type="number"
                                    validate={{ required: { value: true } }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.quantity}
                                    onChange={(e) => {
                                      validation.setFieldValue("quantity", e.target.value);
                                      if (validation.values.njop) {
                                        validation.setFieldValue("price", parseFloat(e.target.value) * parseFloat(validation.values.njop));
                                      }
                                    }}
                                  />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="njop-field" className="form-label">
                                    {t("Harga Beli Per Meter")}
                                  </Label>
                                  <Input
                                    name="njop"
                                    id="njop-field"
                                    className="form-control"
                                    placeholder="Isi Harga Beli"
                                    type="number"
                                    validate={{ required: { value: true } }}
                                    onChange={(e) => {
                                      validation.setFieldValue("njop", e.target.value);
                                      if (validation.values.quantity) {
                                        validation.setFieldValue("price", parseFloat(e.target.value) * parseFloat(validation.values.quantity));
                                      }
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.njop}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="quantity_real-field" className="form-label">
                                    {t("Luas Ukur")}
                                  </Label>
                                  <Input name="quantity_real" id="quantity_real-field" className="form-control" placeholder="Isi Luas Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.quantity_real} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price-field" className="form-label">
                                    {t("Harga Pembelian")}
                                  </Label>
                                  <Input name="price" id="price-field" className="form-control" placeholder="Isi Harga Pembelian Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price_other-field" className="form-label">
                                    {t("Harga SPH")}
                                  </Label>
                                  <Input name="price_other" id="price_other-field" className="form-control" placeholder="Isi Harga SPH Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price_other} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price_fee-field" className="form-label">
                                    {t("Harga Fee Mediator")}
                                  </Label>
                                  <Input name="price_fee" id="price_fee-field" className="form-control" placeholder="Isi Harga SPH Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price_fee} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price_tax-field" className="form-label">
                                    {t("Harga Pajak Terutang")}
                                  </Label>
                                  <Input name="price_tax" id="price_tax-field" className="form-control" placeholder="Isi Harga SPH Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price_tax} />
                                </div>
                                <div className="mb-3 col-lg-6">
                                  <Label htmlFor="price_pph-field" className="form-label">
                                    {t("Harga PPH")}
                                  </Label>
                                  <Input name="price_pph" id="price_pph-field" className="form-control" placeholder="Isi Harga SPH Tanah" type="number" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.price_pph} />
                                </div>

                                <div className="mb-3 col-lg-12">
                                  <Label htmlFor="active-status" className="form-label">
                                    Status
                                  </Label>
                                  <Select
                                    name="legal_status_legal"
                                    value={validation.values.legal_status_legal}
                                    placeholder="Pilih Status"
                                    onChange={(e) => {
                                      validation.setFieldValue("legal_status_legal", e);
                                    }}
                                    options={legalStatusList}
                                  ></Select>
                                </div>

                              </div>
                              <div className="mb-3 d-none">
                                <Label htmlFor="street-field" className="form-label">
                                  {t("Alamat")}
                                </Label>
                                <Input name="street" id="street-field" className="form-control" placeholder="Isi Alamat" type="textarea" onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.street ?? ""} />
                              </div>

                              {(clientLoading || companyLoading) && (
                                <div className="position-absolute top-0">
                                  <Spinner color="primary" type="grow" size={"sm"}>
                                    Loading...
                                  </Spinner>
                                  &nbsp;
                                  <Spinner color="success" type="grow" size={"sm"}>
                                    Loading...
                                  </Spinner>
                                  &nbsp;
                                </div>
                              )}
                            </Col>
                            <Col lg={7} className="ps-3">
                              <div className="mb-3">
                                <div className="row">
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Grup Usaha
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="client"
                                        value={validation.values.client}
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        placeholder="Pilih Grup Usaha"
                                        onChange={(e) => {
                                          validation.setFieldValue("client", e);
                                        }}
                                        options={clientList}
                                      ></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}
                                      >
                                        {clientLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validation.touched.client && validation.errors.client && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.client}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Perusahaan
                                    </Label>
                                    <div className="position-relative">
                                      <Select
                                        name="company"
                                        value={validation.values.company}
                                        placeholder="Pilih Perusahaan"
                                        isDisabled={userType === "admin" || userType === "client" ? false : true}
                                        onChange={(e) => {
                                          setDepartmentList([]);
                                          dispatch(setBranchSelect(null));
                                          dispatch(setCompanySelect(e));
                                          validation.setFieldValue("company", e);
                                          handleGetDepartment(e.value);
                                          handleGetNominatif(e.value);
                                        }}
                                        options={companyList}
                                      ></Select>
                                      <div
                                        className="position-absolute"
                                        style={{
                                          top: "12px",
                                          left: "-24px",
                                        }}
                                      >
                                        {companyLoading && (
                                          <Spinner color="primary" size="sm">
                                            Loading...
                                          </Spinner>
                                        )}
                                      </div>
                                    </div>
                                    {validation.touched.company && validation.errors.company && (
                                      <p className="invalid-feedback d-block" type="invalid">
                                        {validation.errors.company}
                                      </p>
                                    )}
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="pic-field" className="form-label">
                                      {t("PIC Aset")}
                                    </Label>
                                    <Input name="pic" id="pic-field" className="form-control" placeholder="Isi PIC Aset" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.pic} />
                                  </div>
                                  <div className="mb-3 col-lg-6">
                                    <Label htmlFor="address-field" className="form-label">
                                      {t("Departemen")}
                                    </Label>
                                    <Select
                                      name="department"
                                      value={validation.values.department}
                                      placeholder="Pilih Departemen"
                                      onChange={(e) => {
                                        validation.setFieldValue("department", e);
                                      }}
                                      options={departmentList}
                                    ></Select>
                                  </div>
                                  <div className="mb-3 col-lg-6 ">
                                    <Label htmlFor="latitude-field" className="form-label">
                                      Latitude
                                    </Label>
                                    <Input name="latitude" id="latitude-field" className="form-control" placeholder="Isi Latitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.latitude ?? ""} />
                                  </div>
                                  <div className="mb-3 col-lg-6 ">
                                    <Label htmlFor="longitude-field" className="form-label">
                                      Longitude
                                    </Label>
                                    <Input name="longitude" id="longitude-field" className="form-control" placeholder="Isi Longitude" type="text" validate={{ required: { value: true } }} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.longitude ?? ""} />
                                  </div>
                                </div>

                                <div className="mb-3">
                                  <Label htmlFor="des-field" className="form-label">
                                    {t("Keterangan")}
                                  </Label>
                                  <Input name="description" id="des-field" className="form-control" placeholder="Isi Keterangan" type="textarea" rows={3} onChange={validation.handleChange} onBlur={validation.handleBlur} value={validation.values.description ?? ""} />
                                </div>

                                <div className="mb-3 d-flex justify-content-between">
                                  <Label htmlFor="taskFiles" className="form-label me-3">
                                    Foto Area / Dokumen
                                  </Label>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-label btn-soft-success"
                                    onClick={() => {
                                      toggleMedia();
                                    }}
                                  >
                                    <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                                  </button>
                                </div>
                                {assetFiles.map((assetFile, i) => {
                                  if (assetFile.isDeleted) {
                                    return null;
                                  } else {
                                    return (
                                      <div key={i} className="border-bottom mb-3">
                                        <div className="d-flex justify-content-between mb-3 align-items-center">
                                          <div className="me-2">
                                            <img src={assetFile.filename === "" ? defaultImg : `${api.MEDIA_URL}/media/${assetFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                          </div>
                                          <div className="text-truncate">{assetFile.originalname}</div>
                                          <div>
                                            <Link
                                              to="#"
                                              className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                              onClick={(e) => {
                                                handleDeleteFile(assetFile);
                                              }}>
                                              <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                            </Link>
                                          </div>
                                        </div>
                                      </div>
                                    );
                                  }
                                })}

                                <h5 className="mb-3 border-bottom pb-3">Legalitas Dokumen</h5>
                                <div className="d-none">
                                  {legalityAssets.map((o, idx) => {
                                    if (validation.values.legality.length > 0) {
                                      return (
                                        <div key={idx} className="row ms-1">
                                          <div className="form-check form-switch form-switch-custom form-switch-success mb-2 col-lg-6">
                                            <Input
                                              className={"form-check-input checked-all checked-method-all check-" + o.id + idx}
                                              type="checkbox"
                                              role="switch"
                                              value={validation.values.legality[idx]?.id}
                                              defaultChecked={o.id === validation.values.legality[idx]?.id && validation.values.legality[idx]?.id !== 0 ? true : false}
                                              onChange={(e) => {
                                                if (e.target.checked) validation.setFieldValue(`legality[${idx}].id`, o.id);
                                                else validation.setFieldValue(`legality[${idx}].id`, 0);
                                              }}
                                            />
                                            <Label className="form-check-label text-dark text-uppercase fs-12" htmlFor={"check-" + o.id + idx}>
                                              {o.name}
                                            </Label>
                                          </div>
                                          <div className="mb-2 col-lg-2 d-none">
                                            <Flatpickr
                                              className="form-control"
                                              placeholder="Target"
                                              options={{ mode: "single", dateFormat: "Y/m/d" }}
                                              onChange={(selectedDates, dateStr) => {
                                                validation.setFieldValue(`legality[${idx}].targetat`, dateStr);
                                              }}
                                              value={validation.values.legality[idx]?.targetat}
                                            />
                                          </div>
                                          <div className="mb-2 col-lg-2 d-none">
                                            <Flatpickr
                                              className="form-control"
                                              placeholder="Actual"
                                              options={{ mode: "single", dateFormat: "Y/m/d" }}
                                              onChange={(selectedDates, dateStr) => {
                                                if (validation.values.legality[idx]) validation.values.legality[idx].actualat = dateStr;
                                              }}
                                              value={validation.values.legality[idx]?.actualat}
                                            />
                                          </div>
                                          <div className="mb-2 col-lg-6">
                                            <Input
                                              type="textarea"
                                              className="form-control"
                                              placeholder="Keterangan jika ada"
                                              value={validation.values.legality[idx]?.description}
                                              onChange={(e) => {
                                                validation.setFieldValue(`legality[${idx}].description`, e.target.value);
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    } else return null;
                                  })}
                                </div>
                              </div>
                              <div>
                                <div className="justify-content-between mb-3 border border-top-0 border-start-0 border-end-0 pb-2">
                                  <span className="text-muted mt-2 me-2 text-uppercase fw-semibold">UPLOAD DATA DIRI</span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => {
                                      handleLegalDetailAdd("profile");
                                    }}
                                  >
                                    <i className="ri-add-fill fs-12 me-1"></i>Tambah
                                  </button>
                                </div>
                                <div>
                                  {profileFiles &&
                                    profileFiles.map((file, i) => {
                                      return (
                                        <div key={i}>
                                          {file.filename && (
                                            <p
                                              className="fs-18 m-1 text-info"
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  //
                                                }
                                              }}>
                                              {renderIcon(file.filename)} <span className="fs-12 fw-normal">{file.originalname}</span>
                                            </p>
                                          )}
                                          <div className="d-flex justify-content-between mb-2">
                                            <Input
                                              placeholder="Keterangan"
                                              type="text"
                                              className="form-control me-2 product-price w-100"
                                              value={profileFiles[i].description}
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) => {
                                                profileFiles[i].description = e.target.value;
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-soft-success btn-sm me-2"
                                              onClick={(e) => {
                                                toggleMedia();
                                                setCurrentImage("profile");
                                                setCurrentImageIndex(i);
                                              }}>
                                              <i className=" ri-file-2-line fs-15"></i>
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-soft-danger btn-sm me-2"
                                              onClick={(e) => {
                                                onClickDeleteDetailItem(file.filename, "profile");
                                              }}>
                                              <i className=" ri-delete-bin-line fs-15 text-danger"></i>
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                                <div className="justify-content-between mb-3 mt-3 border border-top-0 border-start-0 border-end-0 pb-2">
                                  <span className="text-muted mt-2 me-2 text-uppercase fw-semibold">UPLOAD LEGALITAS</span>
                                  <button
                                    type="button"
                                    className="btn btn-sm btn-soft-success"
                                    onClick={() => {
                                      handleLegalDetailAdd("detail");
                                    }}>
                                    <i className="ri-add-fill fs-12 me-1"></i>Tambah
                                  </button>
                                </div>
                                <div>
                                  {detailFiles &&
                                    detailFiles.map((file, i) => {
                                      return (
                                        <div key={i + "legal"}>
                                          {file.filename && (
                                            <p
                                              className="fs-18 m-1 text-info"
                                              onClick={() => {
                                                const typeFile = file.filename.split(".");
                                                if (typeFile[typeFile.length - 1] === "x-compressed") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "sheet") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else if (typeFile[typeFile.length - 1] === "pdf") {
                                                  window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                                                } else {
                                                  //
                                                }
                                              }}>
                                              {renderIcon(file.filename)} <span className="fs-12 fw-normal">{file.originalname}</span>
                                            </p>
                                          )}
                                          <div className="d-flex justify-content-between mb-2">
                                            <Input
                                              placeholder="Keterangan"
                                              type="text"
                                              className="form-control me-2 product-price w-100"
                                              value={detailFiles[i].description}
                                              onFocus={(e) => e.target.select()}
                                              onChange={(e) => {
                                                detailFiles[i].description = e.target.value;
                                              }}
                                              onBlur={validation.handleBlur}
                                            />
                                            <button
                                              type="button"
                                              className="btn btn-soft-success btn-sm me-2"
                                              onClick={(e) => {
                                                toggleMedia();
                                                setCurrentImage("detail");
                                                setCurrentImageIndex(i);
                                              }}>
                                              <i className=" ri-file-2-line fs-15"></i>
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-soft-danger btn-sm me-2"
                                              onClick={(e) => {
                                                onClickDeleteDetailItem(file.filename, "detail");
                                              }}>
                                              <i className=" ri-delete-bin-line fs-15 text-danger"></i>
                                            </button>
                                          </div>
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </CardBody>
                      </ModalBody>
                      <div className="modal-footer">
                        <div className="hstack gap-2 justify-content-end">
                          <button
                            type="button"
                            className="btn btn-light"
                            onClick={() => {
                              setModal(false);
                              validation.resetForm({});
                            }}
                          >
                            TUTUP
                          </button>

                          <button type="submit" className="btn btn-success" disabled={loading}>
                            <span className="d-flex align-items-center">
                              SIMPAN
                              {loading && (
                                <Spinner size="sm" className="flex-shrink-0" role="status">
                                  Loading...
                                </Spinner>
                              )}
                            </span>
                          </button>
                        </div>
                      </div>
                    </Form>
                  </Modal>
                  <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
                </CardBody>
              </Card>
            </Col>
            <Col lg={3}>
              <Card className="table-responsive">
                <div className="card-body">
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Dokumen Legalitas:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.legal_detail || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "file"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" colSpan={2} className="p-2 pt-3 pb-3">
                          Dokumen Data Diri:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {(info.legal_profile || []).map((file, key) => {
                        let src;
                        return (
                          <tr
                            key={key + "filehak"}
                            className="cursor-pointer"
                            onClick={() => {
                              const typeFile = file.filename.split(".");
                              if (typeFile[typeFile.length - 1] === "x-compressed") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "sheet") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else if (typeFile[typeFile.length - 1] === "pdf") {
                                window.open(`${api.MEDIA_URL}/media/${file.filename}`);
                              } else {
                                //
                              }
                            }}
                          >
                            <td colSpan={2}>
                              <div className="d-flex">
                                <div className="flex-shrink-0 fs-17 me-2 filelist-icon">
                                  <span className="fs-18 text-info">{renderIcon(file.filename)}</span>
                                </div>
                                <div className="flex-grow-1 text-start">
                                  <p className="fw-semibold mb-1 mt-1">{file.description}</p>
                                  <p>{file.originalname}</p>
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      })}

                      <tr>
                        <td className="p-2">Harga Tanah</td>
                        <td className="p-2">
                          {currencyFormat(info.price)}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Harga SPH</td>
                        <td className="p-2">
                          {currencyFormat(info.price_other)}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Harga Fee Mediator</td>
                        <td className="p-2">
                          {currencyFormat(info.price_fee)}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Harga Terhutang Pajak</td>
                        <td className="p-2">
                          {currencyFormat(info.price_tax)}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Harga PPH</td>
                        <td className="p-2">
                          {currencyFormat(info.price_pph)}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <h6 className="fw-semibold mb-2">Keterangan</h6>
                  <p className="mb-4">{info.description ? info.description : "-"} </p>
                  <div className="table-card p-3">
                    <Row>
                      <Col xxl={12}>
                        <table className="table border table-responsive fs-13 mb-3 d-none">
                          <tbody>
                            <tr>
                              <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                                PROGRESS PEMBEBASAN LAHAN
                              </td>
                            </tr>
                            {info.legality &&
                              info.legality.map((o, idx) => {
                                let row = o || {};
                                return (
                                  <Fragment key={idx}>
                                    <tr>
                                      <td className="p2 border-top-0">
                                        {/* {row.targetat ? row.targetat : "-"} s.d {row.actualat ? row.actualat : "-"} */}
                                        <span className="fw-semibold">
                                          <i className={row.id ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line text-danger me-1"}></i> {row.name ? row.name : "-"}
                                        </span>
                                        ,
                                      </td>
                                    </tr>
                                    {row.description && row.description !== "" && (
                                      <>
                                        <tr>
                                          <td className="p2 border-0">{row.description ? row.description : "-"}</td>
                                        </tr>
                                      </>
                                    )}
                                  </Fragment>
                                );
                              })}
                          </tbody>
                        </table>
                      </Col>
                    </Row>
                  </div>
                </div>
                <CardBody className="text-center">
                  <MapContainer center={locationCord} zoom={12} style={{ height: "300px" }}>
                    <TileLayer attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                    <Marker position={locationCord}>
                      <Popup>{info.branch_branch && info.branch_branch.name ? info.branch_branch.name : "-"}</Popup>
                    </Marker>
                  </MapContainer>
                  <table className="table align-middle table-nowrap mb-3">
                    <thead className="table-active">
                      <tr>
                        <th scope="col" className="p-2 pt-3 pb-3">
                          Foto Lokasi Pertanahan:
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="p-2 pt-3 pb-3">
                          <div className="row">
                            {info.legal_file &&
                              info.legal_file.length > 0 &&
                              info.legal_file.map((f, i) => {
                                return (
                                  <div key={i} className="col-lg-4">
                                    <div className="position-relative d-inline-block mx-auto">
                                      <ModalImage showRotate={true} small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`} large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`} alt={info.name} className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table border table-responsive fs-13 mb-3">
                    <tbody>
                      <tr>
                        <td className="p2 fw-medium text-primary text-uppercase" colSpan={"2"}>
                          INFORMASI LAINNYA
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Perusahaan</td>
                        <td className="p-2">{info.legal_company && info.legal_company.name ? info.legal_company.name : "-"} </td>
                      </tr>
                      <tr>
                        <td className="p-2">Area</td>
                        <td className="p-2">
                          {info.latitude}, {info.longitude}
                        </td>
                      </tr>
                      <tr>
                        <td className="p-2">Dibuat Oleh</td>
                        <td className="p-2">{info.legal_createdby && info.legal_createdby.name ? info.legal_createdby.name + " - " + handleValidDate(info.createdat) : "-"}</td>
                      </tr>
                      <tr>
                        <td className="p-2">Diedit Oleh</td>
                        <td className="p-2">{info.legal_updatedby && info.legal_updatedby.name ? info.legal_updatedby.name + " - " + handleValidDate(info.updatedat) : "-"}</td>
                      </tr>
                    </tbody>
                  </table>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <Modal id="showModalAccPayable" isOpen={modalAccPayable} centered size="lg">
          <ModalHeader className="bg-light p-3" toggle={toggleAccPayable}>
            TAGIHAN {info?.name}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationAccPayable.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              <div className="row">
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Jumlah
                  </Label>
                  <CurrencyInput
                    id="amount"
                    name="amount"
                    prefix="Rp. "
                    style={{ border: "1px solid #ccc" }}
                    className="form-control product-price"
                    placeholder="Terbayar"
                    value={validationAccPayable.values.amount}
                    decimalsLimit={2}
                    onFocus={(e) => e.target.select()}
                    onValueChange={(value, name, values) => {
                      let amount = !isNaN(parseFloat(info.amount)) ? parseFloat(info.amount) : 0;
                      validationAccPayable.setFieldValue("amount", parseFloat(value));
                    }}
                  />
                  {validationAccPayable.touched.amount && validationAccPayable.errors.amount && (
                    <p className="invalid-feedback d-block" type="invalid">
                      {validationAccPayable.errors.amount}
                    </p>
                  )}
                </div>
                <div className="mb-3 col-lg-4">
                  <Label htmlFor="amount-field" className="form-label">
                    Tanggal Tagihan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-publish-input"
                    placeholder="Select transaction date"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationAccPayable.setFieldValue("transactionat", dateStr);
                    }}
                    value={validationAccPayable.values.transactionat ?? ""}
                  />
                </div>
                <div className="mb-3 col-lg-4">
                  <Label className="form-label">Cashflow</Label>
                  <Select
                    name="cashflow"
                    value={validationAccPayable.values.cashflow}
                    placeholder="Pilih Cashflow"
                    onChange={(e) => {
                      validationAccPayable.setFieldValue("cashflow", e);
                    }}
                    options={budgetList}
                  ></Select>
                  {validationAccPayable.touched.cashflow && validationAccPayable.errors.cashflow && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.cashflow}
                    </small>
                  )}
                </div>
                <div className="mb-3">
                  <Label htmlFor="address-field" className="form-label">
                    Keterangan
                  </Label>
                  <Input type="textarea" className="form-control" id="description" placeholder="Isi Keterangan " name="description" rows={3} value={validationAccPayable.values.description ?? ""} onBlur={validationAccPayable.handleBlur} onChange={validationAccPayable.handleChange} invalid={validationAccPayable.touched.description && validationAccPayable.errors.description ? true : false} />
                  {validationAccPayable.touched.description && validationAccPayable.errors.description && (
                    <small className="text-danger" type="invalid">
                      {validationAccPayable.errors.description}
                    </small>
                  )}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalAccPayable(false);
                    validationAccPayable.resetForm();
                  }}
                >
                  Close
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1 me-2">SIMPAN TAGIHAN</span>
                    {loading && (
                      <Spinner size="sm" className="flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>


        <Modal id="showModal" isOpen={modalNominatif} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleNominatif}>
            {!!isEdit ? "EDIT DATA NOMINATIF" : "TAMBAH DATA NOMINATIF"}
          </ModalHeader>
          <Form
            onSubmit={(e) => {
              e.preventDefault();
              validationNom.handleSubmit();
              return false;
            }}
          >
            <ModalBody>
              <div className="row border-bottom mb-1 pb-2">
                <div className="mb-1">
                  <Input name="isCert" id="isCert-field" className="form-check-input" type="checkbox" onChange={validationNom.handleChange} onBlur={validationNom.handleBlur} checked={validationNom.values.isCert} /> &nbsp;
                  <Label htmlFor="isCert-field" className="form-label">
                    MAILING UNTUK SERTIFIKAT
                  </Label>
                </div>
                <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Diri Pemilik</h5>
                <div className="mb-3 col-lg-3 d-none">
                  <Label htmlFor="client-field" className="form-label">
                    Grup Usaha&nbsp;
                    {clientLoading && (
                      <Spinner color="primary" size="sm">
                        Loading...
                      </Spinner>
                    )}
                  </Label>
                  <Select
                    name="client"
                    value={validationNom.values.client}
                    isDisabled={userType === "admin" || userType === "client" ? false : true}
                    placeholder="Pilih Grup Usaha"
                    onChange={(e) => {
                      dispatch(setClientSelect(e));
                      validationNom.setFieldValue("company", null);
                      validationNom.setFieldValue("client", e);
                    }}
                    options={clientList}
                  ></Select>
                </div>
                <div className="mb-3 col-lg-3 d-none">
                  <Label htmlFor="company-field" className="form-label">
                    Perusahaan&nbsp;
                    {companyLoading && (
                      <Spinner color="primary" size="sm">
                        Loading...
                      </Spinner>
                    )}
                  </Label>
                  <Select
                    name="company"
                    value={validationNom.values.company}
                    placeholder="Pilih Perusahaan"
                    isDisabled={userType === "admin" || userType === "client" ? false : true}
                    onChange={(e) => {
                      dispatch(setCompanySelect(e));
                      validationNom.setFieldValue("branch", null);
                      validationNom.setFieldValue("company", e);
                    }}
                    options={companyList}
                  ></Select>
                </div>
                <div className="mb-3 col-lg-3 d-none">
                  <Label htmlFor="company-field" className="form-label">
                    Cabang / Proyek&nbsp;
                    {companyLoading && (
                      <Spinner color="primary" size="sm">
                        Loading...
                      </Spinner>
                    )}
                  </Label>
                  <Select
                    name="branch"
                    value={validationNom.values.branch}
                    placeholder="Pilih Perusahaan"
                    onChange={(e) => {
                      validationNom.setFieldValue("branch", e);
                    }}
                    options={branchList}
                  ></Select>
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="name-field" className="form-label">
                    Nama
                  </Label>
                  <Input
                    name="nama"
                    id="nama-field"
                    className="form-control"
                    placeholder="Isi Nama Pemilik"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("nama", val);
                    }}
                    value={validationNom.values.nama}
                    invalid={validationNom.touched.nama && validationNom.errors.nama ? true : false}
                  />
                  {validationNom.touched.nama && validationNom.errors.nama ? <FormFeedback type="invalid">{validationNom.errors.nama}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tempat_lahir-field" className="form-label">
                    Tempat Lahir
                  </Label>
                  <Input
                    name="tempat_lahir"
                    id="tempat_lahir-field"
                    className="form-control"
                    placeholder="Isi Tempat Lahir Pemilik"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("tempat_lahir", val);
                    }}
                    value={validationNom.values.tempat_lahir}
                    invalid={validationNom.touched.tempat_lahir && validationNom.errors.tempat_lahir ? true : false}
                  />
                  {validationNom.touched.tempat_lahir && validationNom.errors.tempat_lahir ? <FormFeedback type="invalid">{validationNom.errors.tempat_lahir}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tgl_lahir-field" className="form-label">
                    Tanggal Lahir
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-tgl_lahir-input"
                    placeholder="Pilih Tanggal Lahir Pemilik"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationNom.setFieldValue("tgl_lahir", dateStr);
                      validationNom.setFieldValue("usia", moment().diff(moment(dateStr, "YYYY/MM/DD"), "years"));
                    }}
                    value={validationNom.values.tgl_lahir}
                  />
                  {validationNom.touched.tgl_lahir && validationNom.errors.tgl_lahir ? (
                    <p className="text-danger" type="invalid">
                      {validationNom.errors.tgl_lahir}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="usia-field" className="form-label">
                    Usia
                  </Label>
                  <Input
                    name="usia"
                    id="usia-field"
                    className="form-control"
                    placeholder="Isi Usia Pemilik"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("usia", val);
                    }}
                    value={validationNom.values.usia}
                    invalid={validationNom.touched.usia && validationNom.errors.usia ? true : false}
                  />
                  {validationNom.touched.usia && validationNom.errors.usia && <FormFeedback type="invalid">{validationNom.errors.usia}</FormFeedback>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan-field" className="form-label">
                    Pekerjaan
                  </Label>
                  <Select
                    name="pekerjaan"
                    value={validationNom.values.pekerjaan}
                    placeholder="Pilih Pekerjaan"
                    onChange={(e) => {
                      validationNom.setFieldValue("pekerjaan", e);
                    }}
                    options={pekerjaanData}
                  ></Select>
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="ktp-field" className="form-label">
                    KTP
                  </Label>
                  <Input
                    name="ktp"
                    id="ktp-field"
                    className="form-control"
                    placeholder="Isi Nomor KTP"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("ktp", e.target.value);
                    }}
                    value={validationNom.values.ktp}
                    invalid={validationNom.touched.ktp && validationNom.errors.ktp ? true : false}
                  />
                  {validationNom.touched.ktp && validationNom.errors.ktp && <FormFeedback type="invalid">{validationNom.errors.ktp}</FormFeedback>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alamat_1-field" className="form-label">
                    Alamat 1
                  </Label>
                  <Input
                    name="alamat_1"
                    id="alamat_1-field"
                    className="form-control"
                    placeholder="Isi Alamat 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("alamat_1", e.target.value);
                    }}
                    value={validationNom.values.alamat_1}
                    invalid={validationNom.touched.alamat_1 && validationNom.errors.alamat_1 ? true : false}
                  />
                  {validationNom.touched.alamat_1 && validationNom.errors.alamat_1 && <FormFeedback type="invalid">{validationNom.errors.alamat_1}</FormFeedback>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kota_pemilik-field" className="form-label">
                    Kota Pemilik
                  </Label>
                  <Input
                    name="kota_pemilik"
                    id="kota_pemilik-field"
                    className="form-control"
                    placeholder="Isi Kota Pemilik"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kota_pemilik", e.target.value);
                    }}
                    value={validationNom.values.kota_pemilik}
                    invalid={validationNom.touched.kota_pemilik && validationNom.errors.kota_pemilik ? true : false}
                  />
                  {validationNom.touched.kota_pemilik && validationNom.errors.kota_pemilik && <FormFeedback type="invalid">{validationNom.errors.kota_pemilik}</FormFeedback>}
                </div>
              </div>

              <div className="row border-bottom mb-1 pb-2">
                <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Diri Pasangan</h5>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="name-field" className="form-label">
                    Nama Pasangan
                  </Label>
                  <Input
                    name="nama_pasangan"
                    id="nama_pasangan-field"
                    className="form-control"
                    placeholder="Isi Nama Pasangan"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("nama_pasangan", val);
                    }}
                    value={validationNom.values.nama_pasangan}
                    invalid={validationNom.touched.nama_pasangan && validationNom.errors.nama_pasangan ? true : false}
                  />
                  {validationNom.touched.nama_pasangan && validationNom.errors.nama_pasangan ? <FormFeedback type="invalid">{validationNom.errors.nama_pasangan}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tempat_lhr_pasangan-field" className="form-label">
                    Tempat Lahir
                  </Label>
                  <Input
                    name="tempat_lhr_pasangan"
                    id="tempat_lhr_pasangan-field"
                    className="form-control"
                    placeholder="Isi Tempat Lahir Pasangan"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("tempat_lhr_pasangan", val);
                    }}
                    value={validationNom.values.tempat_lhr_pasangan}
                    invalid={validationNom.touched.tempat_lhr_pasangan && validationNom.errors.tempat_lhr_pasangan ? true : false}
                  />
                  {validationNom.touched.tempat_lhr_pasangan && validationNom.errors.tempat_lhr_pasangan ? <FormFeedback type="invalid">{validationNom.errors.tempat_lhr_pasangan}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tanggal_lhr_pasangan-field" className="form-label">
                    Tanggal Lahir Pasangan
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-tanggal_lhr_pasangan-input"
                    placeholder="Pilih Tanggal Lahir Pasangan"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationNom.setFieldValue("tanggal_lhr_pasangan", dateStr);
                      validationNom.setFieldValue("usia", moment().diff(moment(dateStr, "YYYY/MM/DD"), "years"));
                    }}
                    value={validationNom.values.tanggal_lhr_pasangan}
                  />
                  {validationNom.touched.tanggal_lhr_pasangan && validationNom.errors.tanggal_lhr_pasangan ? (
                    <p className="text-danger" type="invalid">
                      {validationNom.errors.tanggal_lhr_pasangan}
                    </p>
                  ) : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan_pasangan-field" className="form-label">
                    Pekerjaan
                  </Label>
                  <Input
                    name="pekerjaan_pasangan"
                    id="pekerjaan_pasangan-field"
                    className="form-control"
                    placeholder="Isi Pekerjaan Pasangan"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("pekerjaan_pasangan", val);
                    }}
                    value={validationNom.values.pekerjaan_pasangan}
                    invalid={validationNom.touched.pekerjaan_pasangan && validationNom.errors.pekerjaan_pasangan ? true : false}
                  />
                  {validationNom.touched.pekerjaan_pasangan && validationNom.errors.pekerjaan_pasangan ? <FormFeedback type="invalid">{validationNom.errors.pekerjaan_pasangan}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alamat_pasangan-field" className="form-label">
                    Alamat Pasangan
                  </Label>
                  <Input
                    name="alamat_pasangan"
                    id="alamat_pasangan-field"
                    className="form-control"
                    placeholder="Isi Alamat Pasangan"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("alamat_pasangan", val);
                    }}
                    value={validationNom.values.alamat_pasangan}
                    invalid={validationNom.touched.alamat_pasangan && validationNom.errors.alamat_pasangan ? true : false}
                  />
                  {validationNom.touched.alamat_pasangan && validationNom.errors.alamat_pasangan ? <FormFeedback type="invalid">{validationNom.errors.alamat_pasangan}</FormFeedback> : null}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="ktp_pasangan-field" className="form-label">
                    KTP Pasangan
                  </Label>
                  <Input
                    name="ktp_pasangan"
                    id="ktp_pasangan-field"
                    className="form-control"
                    placeholder="Isi KTP Pasangan"
                    type="text"
                    onChange={(e) => {
                      const val = e.target.value;
                      validationNom.setFieldValue("ktp_pasangan", val);
                    }}
                    value={validationNom.values.ktp_pasangan}
                    invalid={validationNom.touched.ktp_pasangan && validationNom.errors.ktp_pasangan ? true : false}
                  />
                  {validationNom.touched.ktp_pasangan && validationNom.errors.ktp_pasangan ? <FormFeedback type="invalid">{validationNom.errors.ktp_pasangan}</FormFeedback> : null}
                </div>
              </div>
              <div className="row border-bottom mb-1 pb-2">
                <h5 className="mb-3 bg-soft-info p-2 pb-3">Data Tanah dan Lokasi Tanah</h5>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="luas_tanah-field" className="form-label">
                    Luas Tanah
                  </Label>
                  <Input
                    name="luas_tanah"
                    id="luas_tanah-field"
                    className="form-control"
                    placeholder="Isi Luas Tanah"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("luas_tanah", e.target.value);
                      validationNom.setFieldValue("terbilang_luas_tanah", numberToWordOnly(parseFloat(e.target.value), "Meter Persegi"));

                      if (validationNom.values.njop) {
                        const harga = parseFloat(e.target.value) * parseFloat(validationNom.values.njop);
                        validationNom.setFieldValue("harga", harga);
                        validationNom.setFieldValue("terbilang_harga", numberToWords(parseFloat(harga), "Rupiah"));
                      }
                    }}
                    value={validationNom.values.luas_tanah}
                    invalid={validationNom.touched.luas_tanah && validationNom.errors.luas_tanah ? true : false}
                  />
                  {validationNom.touched.luas_tanah && validationNom.errors.luas_tanah && <FormFeedback type="invalid">{validationNom.errors.luas_tanah}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kelas_desa-field" className="form-label">
                    Kelas Desa
                  </Label>
                  <Input
                    name="kelas_desa"
                    id="kelas_desa-field"
                    className="form-control"
                    placeholder="Isi Kelas Desa"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kelas_desa", e.target.value);
                    }}
                    value={validationNom.values.kelas_desa}
                    invalid={validationNom.touched.kelas_desa && validationNom.errors.kelas_desa ? true : false}
                  />
                  {validationNom.touched.kelas_desa && validationNom.errors.kelas_desa && <FormFeedback type="invalid">{validationNom.errors.kelas_desa}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="terbilang_luas_tanah-field" className="form-label">
                    Terbilang Luas Tanah
                  </Label>
                  <Input
                    name="terbilang_luas_tanah"
                    id="terbilang_luas_tanah-field"
                    className="form-control"
                    placeholder="Terbilang Luas Tanah"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("terbilang_luas_tanah", e.target.value);
                    }}
                    value={validationNom.values.terbilang_luas_tanah}
                    invalid={validationNom.touched.terbilang_luas_tanah && validationNom.errors.terbilang_luas_tanah ? true : false}
                  />
                  {validationNom.touched.terbilang_luas_tanah && validationNom.errors.terbilang_luas_tanah && <FormFeedback type="invalid">{validationNom.errors.terbilang_luas_tanah}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="no_c-field" className="form-label">
                    No C
                  </Label>
                  <Input
                    name="no_c"
                    id="no_c-field"
                    className="form-control"
                    placeholder="Isi No C"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("no_c", e.target.value);
                    }}
                    value={validationNom.values.no_c}
                    invalid={validationNom.touched.no_c && validationNom.errors.no_c ? true : false}
                  />
                  {validationNom.touched.no_c && validationNom.errors.no_c && <FormFeedback type="invalid">{validationNom.errors.no_c}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="no_persil-field" className="form-label">
                    No Persil
                  </Label>
                  <Input
                    name="no_persil"
                    id="no_persil-field"
                    className="form-control"
                    placeholder="Isi No Persil"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("no_persil", e.target.value);
                    }}
                    value={validationNom.values.no_persil}
                    invalid={validationNom.touched.no_persil && validationNom.errors.no_persil ? true : false}
                  />
                  {validationNom.touched.no_persil && validationNom.errors.no_persil && <FormFeedback type="invalid">{validationNom.errors.no_persil}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="blok-field" className="form-label">
                    Blok
                  </Label>
                  <Input
                    name="blok"
                    id="blok-field"
                    className="form-control"
                    placeholder="Isi Blok"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("blok", e.target.value);
                    }}
                    value={validationNom.values.blok}
                    invalid={validationNom.touched.blok && validationNom.errors.blok ? true : false}
                  />
                  {validationNom.touched.blok && validationNom.errors.blok && <FormFeedback type="invalid">{validationNom.errors.blok}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="nop-field" className="form-label">
                    NOP
                  </Label>
                  <Input
                    name="nop"
                    id="nop-field"
                    className="form-control"
                    placeholder="Isi NOP"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("nop", e.target.value);
                    }}
                    value={validationNom.values.nop}
                    invalid={validationNom.touched.nop && validationNom.errors.nop ? true : false}
                  />
                  {validationNom.touched.nop && validationNom.errors.nop && <FormFeedback type="invalid">{validationNom.errors.nop}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="njop-field" className="form-label">
                    NJOP
                  </Label>
                  <Input
                    name="njop"
                    id="njop-field"
                    className="form-control"
                    placeholder="Isi NJOP"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("njop", e.target.value);
                      const harga = parseFloat(validationNom.values.luas_tanah) * parseFloat(e.target.value);
                      validationNom.setFieldValue("harga", harga);
                      validationNom.setFieldValue("terbilang_harga", numberToWords(parseFloat(harga), "Rupiah"));
                    }}
                    value={validationNom.values.njop}
                    invalid={validationNom.touched.njop && validationNom.errors.njop ? true : false}
                  />
                  {validationNom.touched.njop && validationNom.errors.njop && <FormFeedback type="invalid">{validationNom.errors.njop}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="harga-field" className="form-label">
                    Harga
                  </Label>
                  <Input
                    name="harga"
                    id="harga-field"
                    className="form-control"
                    placeholder="Harga"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("harga", e.target.value);
                    }}
                    value={validationNom.values.harga}
                    invalid={validationNom.touched.harga && validationNom.errors.harga ? true : false}
                  />
                  {validationNom.touched.harga && validationNom.errors.harga && <FormFeedback type="invalid">{validationNom.errors.harga}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="terbilang_harga-field" className="form-label">
                    Terbilang Harga
                  </Label>
                  <Input
                    name="terbilang_harga"
                    id="terbilang_harga-field"
                    className="form-control"
                    placeholder="Terbilang Harga"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("terbilang_harga", e.target.value);
                    }}
                    value={validationNom.values.terbilang_harga}
                    invalid={validationNom.touched.terbilang_harga && validationNom.errors.terbilang_harga ? true : false}
                  />
                  {validationNom.touched.terbilang_harga && validationNom.errors.terbilang_harga && <FormFeedback type="invalid">{validationNom.errors.terbilang_harga}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="letak_tanah-field" className="form-label">
                    Letak Tanah
                  </Label>
                  <Input
                    name="letak_tanah"
                    id="letak_tanah-field"
                    className="form-control"
                    placeholder="Isi Letak Tanah"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("letak_tanah", e.target.value);
                    }}
                    value={validationNom.values.letak_tanah}
                    invalid={validationNom.touched.letak_tanah && validationNom.errors.letak_tanah ? true : false}
                  />
                  {validationNom.touched.letak_tanah && validationNom.errors.letak_tanah && <FormFeedback type="invalid">{validationNom.errors.letak_tanah}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="desa-field" className="form-label">
                    Desa
                  </Label>
                  <Input
                    name="desa"
                    id="desa-field"
                    className="form-control"
                    placeholder="Desa"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("desa", e.target.value);
                    }}
                    value={validationNom.values.desa}
                    invalid={validationNom.touched.desa && validationNom.errors.desa ? true : false}
                  />
                  {validationNom.touched.desa && validationNom.errors.desa && <FormFeedback type="invalid">{validationNom.errors.desa}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kecamatan-field" className="form-label">
                    Kecamatan
                  </Label>
                  <Input
                    name="kecamatan"
                    id="kecamatan-field"
                    className="form-control"
                    placeholder="Kecamatan"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kecamatan", e.target.value);
                    }}
                    value={validationNom.values.kecamatan}
                    invalid={validationNom.touched.kecamatan && validationNom.errors.kecamatan ? true : false}
                  />
                  {validationNom.touched.kecamatan && validationNom.errors.kecamatan && <FormFeedback type="invalid">{validationNom.errors.kecamatan}</FormFeedback>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tempat-field" className="form-label">
                    Tempat
                  </Label>
                  <Input
                    name="tempat"
                    id="tempat-field"
                    className="form-control"
                    placeholder="Isi Tempat"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("tempat", e.target.value);
                    }}
                    value={validationNom.values.tempat}
                    invalid={validationNom.touched.tempat && validationNom.errors.tempat ? true : false}
                  />
                  {validationNom.touched.tempat && validationNom.errors.tempat && <FormFeedback type="invalid">{validationNom.errors.tempat}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tgl-field" className="form-label">
                    Tanggal
                  </Label>
                  <Flatpickr
                    className="form-control"
                    id="datepicker-tgl-input"
                    placeholder="Isi Tanggal"
                    options={{
                      mode: "single",
                      dateFormat: "Y/m/d",
                    }}
                    onChange={(selectedDates, dateStr) => {
                      validationNom.setFieldValue("tgl", dateStr);
                    }}
                    value={validationNom.values.tgl}
                  />
                  {validationNom.touched.tgl && validationNom.errors.tgl ? (
                    <p className="text-danger" type="invalid">
                      {validationNom.errors.tgl}
                    </p>
                  ) : null}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="rt-field" className="form-label">
                    RT
                  </Label>
                  <Input
                    name="rt"
                    id="rt-field"
                    className="form-control"
                    placeholder="Isi Nomor RT"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("rt", e.target.value);
                    }}
                    value={validationNom.values.rt}
                    invalid={validationNom.touched.rt && validationNom.errors.rt ? true : false}
                  />
                  {validationNom.touched.rt && validationNom.errors.rt && <FormFeedback type="invalid">{validationNom.errors.rt}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="rw-field" className="form-label">
                    RW
                  </Label>
                  <Input
                    name="rw"
                    id="rw-field"
                    className="form-control"
                    placeholder="Isi Nomor RW"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("rw", e.target.value);
                    }}
                    value={validationNom.values.rw}
                    invalid={validationNom.touched.rw && validationNom.errors.rw ? true : false}
                  />
                  {validationNom.touched.rw && validationNom.errors.rw && <FormFeedback type="invalid">{validationNom.errors.rw}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="ketua_rt-field" className="form-label">
                    Ketua RT
                  </Label>
                  <Input
                    name="ketua_rt"
                    id="ketua_rt-field"
                    className="form-control"
                    placeholder="Isi Nama Ketua RT"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("ketua_rt", e.target.value);
                    }}
                    value={validationNom.values.ketua_rt}
                    invalid={validationNom.touched.ketua_rt && validationNom.errors.ketua_rt ? true : false}
                  />
                  {validationNom.touched.ketua_rt && validationNom.errors.ketua_rt && <FormFeedback type="invalid">{validationNom.errors.ketua_rt}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="ketua_rw-field" className="form-label">
                    Ketua RW
                  </Label>
                  <Input
                    name="ketua_rw"
                    id="ketua_rw-field"
                    className="form-control"
                    placeholder="Isi Nama Ketua RW"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("ketua_rw", e.target.value);
                    }}
                    value={validationNom.values.ketua_rw}
                    invalid={validationNom.touched.ketua_rw && validationNom.errors.ketua_rw ? true : false}
                  />
                  {validationNom.touched.ketua_rw && validationNom.errors.ketua_rw && <FormFeedback type="invalid">{validationNom.errors.ketua_rw}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kadus-field" className="form-label">
                    Kadus
                  </Label>
                  <Input
                    name="kadus"
                    id="kadus-field"
                    className="form-control"
                    placeholder="Isi Kadus"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kadus", e.target.value);
                    }}
                    value={validationNom.values.kadus}
                    invalid={validationNom.touched.kadus && validationNom.errors.kadus ? true : false}
                  />
                  {validationNom.touched.kadus && validationNom.errors.kadus && <FormFeedback type="invalid">{validationNom.errors.kadus}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="sekdes-field" className="form-label">
                    Sekdes
                  </Label>
                  <Input
                    name="sekdes"
                    id="sekdes-field"
                    className="form-control"
                    placeholder="Isi Nama Sekdes"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("sekdes", e.target.value);
                    }}
                    value={validationNom.values.sekdes}
                    invalid={validationNom.touched.sekdes && validationNom.errors.sekdes ? true : false}
                  />
                  {validationNom.touched.sekdes && validationNom.errors.sekdes && <FormFeedback type="invalid">{validationNom.errors.sekdes}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kepala_desa-field" className="form-label">
                    Kepala Desa
                  </Label>
                  <Input
                    name="kepala_desa"
                    id="kepala_desa-field"
                    className="form-control"
                    placeholder="Isi Kepala Desa"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kepala_desa", e.target.value);
                    }}
                    value={validationNom.values.kepala_desa}
                    invalid={validationNom.touched.kepala_desa && validationNom.errors.kepala_desa ? true : false}
                  />
                  {validationNom.touched.kepala_desa && validationNom.errors.kepala_desa && <FormFeedback type="invalid">{validationNom.errors.kepala_desa}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="utara-field" className="form-label">
                    Batas Utara
                  </Label>
                  <Input
                    name="utara"
                    id="utara-field"
                    className="form-control"
                    placeholder="Isi Batas Utara"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("utara", e.target.value);
                    }}
                    value={validationNom.values.utara}
                    invalid={validationNom.touched.utara && validationNom.errors.utara ? true : false}
                  />
                  {validationNom.touched.utara && validationNom.errors.utara && <FormFeedback type="invalid">{validationNom.errors.utara}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="timur-field" className="form-label">
                    Batas Timur
                  </Label>
                  <Input
                    name="timur"
                    id="timur-field"
                    className="form-control"
                    placeholder="Isi Batas Timur"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("timur", e.target.value);
                    }}
                    value={validationNom.values.timur}
                    invalid={validationNom.touched.timur && validationNom.errors.timur ? true : false}
                  />
                  {validationNom.touched.timur && validationNom.errors.timur && <FormFeedback type="invalid">{validationNom.errors.timur}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="selatan-field" className="form-label">
                    Batas Selatan
                  </Label>
                  <Input
                    name="selatan"
                    id="selatan-field"
                    className="form-control"
                    placeholder="Isi Batas Selatan"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("selatan", e.target.value);
                    }}
                    value={validationNom.values.selatan}
                    invalid={validationNom.touched.selatan && validationNom.errors.selatan ? true : false}
                  />
                  {validationNom.touched.selatan && validationNom.errors.selatan && <FormFeedback type="invalid">{validationNom.errors.selatan}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="barat-field" className="form-label">
                    Batas Barat
                  </Label>
                  <Input
                    name="barat"
                    id="barat-field"
                    className="form-control"
                    placeholder="Isi Batas Barat"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("barat", e.target.value);
                    }}
                    value={validationNom.values.barat}
                    invalid={validationNom.touched.barat && validationNom.errors.barat ? true : false}
                  />
                  {validationNom.touched.barat && validationNom.errors.barat && <FormFeedback type="invalid">{validationNom.errors.barat}</FormFeedback>}
                </div>
              </div>
              <div className="row">
                <h5 className="mb-3 bg-soft-info p-2 pb-3">Riwayat Tanah</h5>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tahun_1-field" className="form-label">
                    Tahun 1
                  </Label>
                  <Input
                    name="tahun_1"
                    id="tahun_1-field"
                    className="form-control"
                    placeholder="Isi Tahun 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("tahun_1", e.target.value);
                    }}
                    value={validationNom.values.tahun_1}
                    invalid={validationNom.touched.tahun_1 && validationNom.errors.tahun_1 ? true : false}
                  />
                  {validationNom.touched.tahun_1 && validationNom.errors.tahun_1 && <FormFeedback type="invalid">{validationNom.errors.tahun_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="ats_nama_1-field" className="form-label">
                    Atas Nama 1
                  </Label>
                  <Input
                    name="ats_nama_1"
                    id="ats_nama_1-field"
                    className="form-control"
                    placeholder="Isi Atas Nama 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("ats_nama_1", e.target.value);
                    }}
                    value={validationNom.values.ats_nama_1}
                    invalid={validationNom.touched.ats_nama_1 && validationNom.errors.ats_nama_1 ? true : false}
                  />
                  {validationNom.touched.ats_nama_1 && validationNom.errors.ats_nama_1 && <FormFeedback type="invalid">{validationNom.errors.ats_nama_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kota_1-field" className="form-label">
                    Kota 1
                  </Label>
                  <Input
                    name="kota_1"
                    id="kota_1-field"
                    className="form-control"
                    placeholder="Isi Kota 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kota_1", e.target.value);
                    }}
                    value={validationNom.values.kota_1}
                    invalid={validationNom.touched.kota_1 && validationNom.errors.kota_1 ? true : false}
                  />
                  {validationNom.touched.kota_1 && validationNom.errors.kota_1 && <FormFeedback type="invalid">{validationNom.errors.kota_1}</FormFeedback>}
                </div>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="berdasarkan_1-field" className="form-label">
                    Berdasarkan 1
                  </Label>
                  <Input
                    name="berdasarkan_1"
                    id="berdasarkan_1-field"
                    className="form-control"
                    placeholder="Isi Berdasarkan 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("berdasarkan_1", e.target.value);
                    }}
                    value={validationNom.values.berdasarkan_1}
                    invalid={validationNom.touched.berdasarkan_1 && validationNom.errors.berdasarkan_1 ? true : false}
                  />
                  {validationNom.touched.berdasarkan_1 && validationNom.errors.berdasarkan_1 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_1}</FormFeedback>}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tahun_2-field" className="form-label">
                    Tahun 2
                  </Label>
                  <Input
                    name="tahun_2"
                    id="tahun_2-field"
                    className="form-control"
                    placeholder="Isi Tahun 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("tahun_2", e.target.value);
                    }}
                    value={validationNom.values.tahun_2}
                    invalid={validationNom.touched.tahun_2 && validationNom.errors.tahun_2 ? true : false}
                  />
                  {validationNom.touched.tahun_2 && validationNom.errors.tahun_2 && <FormFeedback type="invalid">{validationNom.errors.tahun_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="beralih_kepada_2-field" className="form-label">
                    Beralih Kepada 2
                  </Label>
                  <Input
                    name="beralih_kepada_2"
                    id="beralih_kepada_2-field"
                    className="form-control"
                    placeholder="Isi Beralih Kepada 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("beralih_kepada_2", e.target.value);
                    }}
                    value={validationNom.values.beralih_kepada_2}
                    invalid={validationNom.touched.beralih_kepada_2 && validationNom.errors.beralih_kepada_2 ? true : false}
                  />
                  {validationNom.touched.beralih_kepada_2 && validationNom.errors.beralih_kepada_2 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kota_2-field" className="form-label">
                    Kota 2
                  </Label>
                  <Input
                    name="kota_2"
                    id="kota_2-field"
                    className="form-control"
                    placeholder="Isi Kota 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kota_2", e.target.value);
                    }}
                    value={validationNom.values.kota_2}
                    invalid={validationNom.touched.kota_2 && validationNom.errors.kota_2 ? true : false}
                  />
                  {validationNom.touched.kota_2 && validationNom.errors.kota_2 && <FormFeedback type="invalid">{validationNom.errors.kota_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="berdasarkan_2-field" className="form-label">
                    Berdasarkan 2
                  </Label>
                  <Input
                    name="berdasarkan_2"
                    id="berdasarkan_2-field"
                    className="form-control"
                    placeholder="Isi Berdasarkan 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("berdasarkan_2", e.target.value);
                    }}
                    value={validationNom.values.berdasarkan_2}
                    invalid={validationNom.touched.berdasarkan_2 && validationNom.errors.berdasarkan_2 ? true : false}
                  />
                  {validationNom.touched.berdasarkan_2 && validationNom.errors.berdasarkan_2 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_2}</FormFeedback>}
                </div>
              </div>
              <div className="row">
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tahun_3-field" className="form-label">
                    Tahun 3
                  </Label>
                  <Input
                    name="tahun_3"
                    id="tahun_3-field"
                    className="form-control"
                    placeholder="Isi Tahun 3"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("tahun_3", e.target.value);
                    }}
                    value={validationNom.values.tahun_3}
                    invalid={validationNom.touched.tahun_3 && validationNom.errors.tahun_3 ? true : false}
                  />
                  {validationNom.touched.tahun_3 && validationNom.errors.tahun_3 && <FormFeedback type="invalid">{validationNom.errors.tahun_3}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="beralih_kepada_3-field" className="form-label">
                    Beralih Kepada 3
                  </Label>
                  <Input
                    name="beralih_kepada_3"
                    id="beralih_kepada_3-field"
                    className="form-control"
                    placeholder="Isi Beralih Kepada 3"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("beralih_kepada_3", e.target.value);
                    }}
                    value={validationNom.values.beralih_kepada_3}
                    invalid={validationNom.touched.beralih_kepada_3 && validationNom.errors.beralih_kepada_3 ? true : false}
                  />
                  {validationNom.touched.beralih_kepada_3 && validationNom.errors.beralih_kepada_3 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_3}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kota_3-field" className="form-label">
                    Kota 3
                  </Label>
                  <Input
                    name="kota_3"
                    id="kota_3-field"
                    className="form-control"
                    placeholder="Isi Kota 3"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kota_3", e.target.value);
                    }}
                    value={validationNom.values.kota_3}
                    invalid={validationNom.touched.kota_3 && validationNom.errors.kota_3 ? true : false}
                  />
                  {validationNom.touched.kota_3 && validationNom.errors.kota_3 && <FormFeedback type="invalid">{validationNom.errors.kota_3}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="berdasarkan_3-field" className="form-label">
                    Berdasarkan 3
                  </Label>
                  <Input
                    name="berdasarkan_3"
                    id="berdasarkan_3-field"
                    className="form-control"
                    placeholder="Isi Berdasarkan 3"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("berdasarkan_3", e.target.value);
                    }}
                    value={validationNom.values.berdasarkan_3}
                    invalid={validationNom.touched.berdasarkan_3 && validationNom.errors.berdasarkan_3 ? true : false}
                  />
                  {validationNom.touched.berdasarkan_3 && validationNom.errors.berdasarkan_3 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_3}</FormFeedback>}
                </div>
              </div>
              <div className="row border-bottom mb-1 pb-2">
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="tahun_4-field" className="form-label">
                    Tahun 4
                  </Label>
                  <Input
                    name="tahun_4"
                    id="tahun_4-field"
                    className="form-control"
                    placeholder="Isi Tahun 4"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("tahun_4", e.target.value);
                    }}
                    value={validationNom.values.tahun_4}
                    invalid={validationNom.touched.tahun_4 && validationNom.errors.tahun_4 ? true : false}
                  />
                  {validationNom.touched.tahun_4 && validationNom.errors.tahun_4 && <FormFeedback type="invalid">{validationNom.errors.tahun_4}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="beralih_kepada_4-field" className="form-label">
                    Beralih Kepada 4
                  </Label>
                  <Input
                    name="beralih_kepada_4"
                    id="beralih_kepada_4-field"
                    className="form-control"
                    placeholder="Isi Beralih Kepada 4"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("beralih_kepada_4", e.target.value);
                    }}
                    value={validationNom.values.beralih_kepada_4}
                    invalid={validationNom.touched.beralih_kepada_4 && validationNom.errors.beralih_kepada_4 ? true : false}
                  />
                  {validationNom.touched.beralih_kepada_4 && validationNom.errors.beralih_kepada_4 && <FormFeedback type="invalid">{validationNom.errors.beralih_kepada_4}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="kota_4-field" className="form-label">
                    Kota 4
                  </Label>
                  <Input
                    name="kota_4"
                    id="kota_4-field"
                    className="form-control"
                    placeholder="Isi Kota 4"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("kota_4", e.target.value);
                    }}
                    value={validationNom.values.kota_4}
                    invalid={validationNom.touched.kota_4 && validationNom.errors.kota_4 ? true : false}
                  />
                  {validationNom.touched.kota_4 && validationNom.errors.kota_4 && <FormFeedback type="invalid">{validationNom.errors.kota_4}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="berdasarkan_4-field" className="form-label">
                    Berdasarkan 4
                  </Label>
                  <Input
                    name="berdasarkan_4"
                    id="berdasarkan_4-field"
                    className="form-control"
                    placeholder="Isi Berdasarkan 4"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("berdasarkan_4", e.target.value);
                    }}
                    value={validationNom.values.berdasarkan_4}
                    invalid={validationNom.touched.berdasarkan_4 && validationNom.errors.berdasarkan_4 ? true : false}
                  />
                  {validationNom.touched.berdasarkan_4 && validationNom.errors.berdasarkan_4 && <FormFeedback type="invalid">{validationNom.errors.berdasarkan_4}</FormFeedback>}
                </div>
              </div>
              <div className="row border-bottom mb-1 pb-2">
                <h5 className="mb-3 bg-soft-info p-2 pb-3">Saksi Saksi</h5>
                <div className="mb-3 col-lg-3">
                  <Label htmlFor="saksi_sk_1-field" className="form-label">
                    Saksi SK 1 / RT
                  </Label>
                  <Input
                    name="saksi_sk_1"
                    id="saksi_sk_1-field"
                    className="form-control"
                    placeholder="Isi Saksi SK 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("saksi_sk_1", e.target.value);
                    }}
                    value={validationNom.values.saksi_sk_1}
                    invalid={validationNom.touched.saksi_sk_1 && validationNom.errors.saksi_sk_1 ? true : false}
                  />
                  {validationNom.touched.saksi_sk_1 && validationNom.errors.saksi_sk_1 && <FormFeedback type="invalid">{validationNom.errors.saksi_sk_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="umur_sk_1-field" className="form-label">
                    Umur SK 1 / RT
                  </Label>
                  <Input
                    name="umur_sk_1"
                    id="umur_sk_1-field"
                    className="form-control"
                    placeholder="Isi Umur SK 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("umur_sk_1", e.target.value);
                    }}
                    value={validationNom.values.umur_sk_1}
                    invalid={validationNom.touched.umur_sk_1 && validationNom.errors.umur_sk_1 ? true : false}
                  />
                  {validationNom.touched.umur_sk_1 && validationNom.errors.umur_sk_1 && <FormFeedback type="invalid">{validationNom.errors.umur_sk_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan_sk_1-field" className="form-label">
                    Pekerjaan SK 1 / RT
                  </Label>
                  <Input
                    name="pekerjaan_sk_1"
                    id="pekerjaan_sk_1-field"
                    className="form-control"
                    placeholder="Isi  Pekerjaan SK 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("pekerjaan_sk_1", e.target.value);
                    }}
                    value={validationNom.values.pekerjaan_sk_1}
                    invalid={validationNom.touched.pekerjaan_sk_1 && validationNom.errors.pekerjaan_sk_1 ? true : false}
                  />
                  {validationNom.touched.pekerjaan_sk_1 && validationNom.errors.pekerjaan_sk_1 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_sk_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alamat_sk_1-field" className="form-label">
                    Alamat SK 1 / RT
                  </Label>
                  <Input
                    name="alamat_sk_1"
                    id="alamat_sk_1-field"
                    className="form-control"
                    placeholder="Isi Alamat SK 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("alamat_sk_1", e.target.value);
                    }}
                    value={validationNom.values.alamat_sk_1}
                    invalid={validationNom.touched.alamat_sk_1 && validationNom.errors.alamat_sk_1 ? true : false}
                  />
                  {validationNom.touched.alamat_sk_1 && validationNom.errors.alamat_sk_1 && <FormFeedback type="invalid">{validationNom.errors.alamat_sk_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="saksi_sk_2-field" className="form-label">
                    Saksi SK 2 / SekDes
                  </Label>
                  <Input
                    name="saksi_sk_2"
                    id="saksi_sk_2-field"
                    className="form-control"
                    placeholder="Isi Saksi SK 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("saksi_sk_2", e.target.value);
                    }}
                    value={validationNom.values.saksi_sk_2}
                    invalid={validationNom.touched.saksi_sk_2 && validationNom.errors.saksi_sk_2 ? true : false}
                  />
                  {validationNom.touched.saksi_sk_2 && validationNom.errors.saksi_sk_2 && <FormFeedback type="invalid">{validationNom.errors.saksi_sk_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="umur_sk_2-field" className="form-label">
                    Umur SK 2 / SekDes
                  </Label>
                  <Input
                    name="umur_sk_2"
                    id="umur_sk_2-field"
                    className="form-control"
                    placeholder="Isi Umur SK 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("umur_sk_2", e.target.value);
                    }}
                    value={validationNom.values.umur_sk_2}
                    invalid={validationNom.touched.umur_sk_2 && validationNom.errors.umur_sk_2 ? true : false}
                  />
                  {validationNom.touched.umur_sk_2 && validationNom.errors.umur_sk_2 && <FormFeedback type="invalid">{validationNom.errors.umur_sk_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan_sk_2-field" className="form-label">
                    Pekerjaan SK 2 / Sekdes
                  </Label>
                  <Input
                    name="pekerjaan_sk_2"
                    id="pekerjaan_sk_2-field"
                    className="form-control"
                    placeholder="Isi Pekerjaan SK 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("pekerjaan_sk_2", e.target.value);
                    }}
                    value={validationNom.values.pekerjaan_sk_2}
                    invalid={validationNom.touched.pekerjaan_sk_2 && validationNom.errors.pekerjaan_sk_2 ? true : false}
                  />
                  {validationNom.touched.pekerjaan_sk_2 && validationNom.errors.pekerjaan_sk_2 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_sk_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alamat_sk_2-field" className="form-label">
                    Alamat SK 2 / Sekdes
                  </Label>
                  <Input
                    name="alamat_sk_2"
                    id="alamat_sk_2-field"
                    className="form-control"
                    placeholder="Isi Alamat SK 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("alamat_sk_2", e.target.value);
                    }}
                    value={validationNom.values.alamat_sk_2}
                    invalid={validationNom.touched.alamat_sk_2 && validationNom.errors.alamat_sk_2 ? true : false}
                  />
                  {validationNom.touched.alamat_sk_2 && validationNom.errors.alamat_sk_2 && <FormFeedback type="invalid">{validationNom.errors.alamat_sk_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="nama_2-field" className="form-label">
                    Nama 2
                  </Label>
                  <Input
                    name="nama_2"
                    id="nama_2-field"
                    className="form-control"
                    placeholder="Isi Nama 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("nama_2", e.target.value);
                    }}
                    value={validationNom.values.nama_2}
                    invalid={validationNom.touched.nama_2 && validationNom.errors.nama_2 ? true : false}
                  />
                  {validationNom.touched.nama_2 && validationNom.errors.nama_2 && <FormFeedback type="invalid">{validationNom.errors.nama_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="warga_negara-field" className="form-label">
                    Warga Negara
                  </Label>
                  <Input
                    name="warga_negara"
                    id="warga_negara-field"
                    className="form-control"
                    placeholder="Isi Warga Negara"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("warga_negara", e.target.value);
                    }}
                    value={validationNom.values.warga_negara}
                    invalid={validationNom.touched.warga_negara && validationNom.errors.warga_negara ? true : false}
                  />
                  {validationNom.touched.warga_negara && validationNom.errors.warga_negara && <FormFeedback type="invalid">{validationNom.errors.warga_negara}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alih_2-field" className="form-label">
                    Peralihan
                  </Label>
                  <Input
                    name="alih_2"
                    id="alih_2-field"
                    className="form-control"
                    placeholder="Isi Peralihan"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("alih_2", e.target.value);
                    }}
                    value={validationNom.values.alih_2}
                    invalid={validationNom.touched.alih_2 && validationNom.errors.alih_2 ? true : false}
                  />
                  {validationNom.touched.alih_2 && validationNom.errors.alih_2 && <FormFeedback type="invalid">{validationNom.errors.alih_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="jenis-field" className="form-label">
                    Jenis (TANAH DARAT / SAWAH KERING)
                  </Label>
                  <Input
                    name="jenis"
                    id="jenis-field"
                    className="form-control"
                    placeholder="Isi Jenis"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("jenis", e.target.value);
                    }}
                    value={validationNom.values.jenis}
                    invalid={validationNom.touched.jenis && validationNom.errors.jenis ? true : false}
                  />
                  {validationNom.touched.jenis && validationNom.errors.jenis && <FormFeedback type="invalid">{validationNom.errors.jenis}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan-field" className="form-label">
                    Jenis Blanko C
                  </Label>
                  <Select
                    name="blankoc"
                    value={validationNom.values.blankoc}
                    placeholder="Pilih Jenis Blanko C"
                    onChange={(e) => {
                      validationNom.setFieldValue("blankoc", e);
                    }}
                    options={blankocData}
                  ></Select>
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="dasar-field" className="form-label">
                    Dasar
                  </Label>
                  <Input
                    name="dasar"
                    id="dasar-field"
                    className="form-control"
                    placeholder="Isi Dasar"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("dasar", e.target.value);
                    }}
                    value={validationNom.values.dasar}
                    invalid={validationNom.touched.dasar && validationNom.errors.dasar ? true : false}
                  />
                  {validationNom.touched.dasar && validationNom.errors.dasar && <FormFeedback type="invalid">{validationNom.errors.dasar}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="saksi_st_1-field" className="form-label">
                    Saksi Sertifikat 1
                  </Label>
                  <Input
                    name="saksi_st_1"
                    id="saksi_st_1-field"
                    className="form-control"
                    placeholder="Isi Saksi Sertifikat 1"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("saksi_st_1", e.target.value);
                    }}
                    value={validationNom.values.saksi_st_1}
                    invalid={validationNom.touched.saksi_st_1 && validationNom.errors.saksi_st_1 ? true : false}
                  />
                  {validationNom.touched.saksi_st_1 && validationNom.errors.saksi_st_1 && <FormFeedback type="invalid">{validationNom.errors.saksi_st_1}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="usia_2-field" className="form-label">
                    Usia 2
                  </Label>
                  <Input
                    name="usia_2"
                    id="usia_2-field"
                    className="form-control"
                    placeholder="Isi Usia 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("usia_2", e.target.value);
                    }}
                    value={validationNom.values.usia_2}
                    invalid={validationNom.touched.usia_2 && validationNom.errors.usia_2 ? true : false}
                  />
                  {validationNom.touched.usia_2 && validationNom.errors.usia_2 && <FormFeedback type="invalid">{validationNom.errors.usia_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="pekerjaan_2-field" className="form-label">
                    Pekerjaan 2
                  </Label>
                  <Input
                    name="pekerjaan_2"
                    id="pekerjaan_2-field"
                    className="form-control"
                    placeholder="Isi Pekerjaan 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("pekerjaan_2", e.target.value);
                    }}
                    value={validationNom.values.pekerjaan_2}
                    invalid={validationNom.touched.pekerjaan_2 && validationNom.errors.pekerjaan_2 ? true : false}
                  />
                  {validationNom.touched.pekerjaan_2 && validationNom.errors.pekerjaan_2 && <FormFeedback type="invalid">{validationNom.errors.pekerjaan_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="alamat_2-field" className="form-label">
                    Alamat 2
                  </Label>
                  <Input
                    name="alamat_2"
                    id="alamat_2-field"
                    className="form-control"
                    placeholder="Isi Alamat 2"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("alamat_2", e.target.value);
                    }}
                    value={validationNom.values.alamat_2}
                    invalid={validationNom.touched.alamat_2 && validationNom.errors.alamat_2 ? true : false}
                  />
                  {validationNom.touched.alamat_2 && validationNom.errors.alamat_2 && <FormFeedback type="invalid">{validationNom.errors.alamat_2}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="no_sph-field" className="form-label">
                    No SPH
                  </Label>
                  <Input
                    name="no_sph"
                    id="no_sph-field"
                    className="form-control"
                    placeholder="Isi No SPH"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("no_sph", e.target.value);
                    }}
                    value={validationNom.values.no_sph}
                    invalid={validationNom.touched.no_sph && validationNom.errors.no_sph ? true : false}
                  />
                  {validationNom.touched.no_sph && validationNom.errors.no_sph && <FormFeedback type="invalid">{validationNom.errors.no_sph}</FormFeedback>}
                </div>

                <div className="mb-3 col-lg-3">
                  <Label htmlFor="no_ijin_lksi-field" className="form-label">
                    No Ijin Lokasi
                  </Label>
                  <Input
                    name="no_ijin_lksi"
                    id="no_ijin_lksi-field"
                    className="form-control"
                    placeholder="Isi No Ijin Lokasi"
                    type="text"
                    onChange={(e) => {
                      validationNom.setFieldValue("no_ijin_lksi", e.target.value);
                    }}
                    value={validationNom.values.no_ijin_lksi}
                    invalid={validationNom.touched.no_ijin_lksi && validationNom.errors.no_ijin_lksi ? true : false}
                  />
                  {validationNom.touched.no_ijin_lksi && validationNom.errors.no_ijin_lksi && <FormFeedback type="invalid">{validationNom.errors.no_ijin_lksi}</FormFeedback>}
                </div>
              </div>
            </ModalBody>
            <div className="modal-footer">
              <div className="hstack gap-2 justify-content-end">
                <button
                  type="button"
                  className="btn btn-light"
                  onClick={() => {
                    setModalNominatif(false);
                  }}
                >
                  Tutup
                </button>
                <button type="submit" className="btn btn-success">
                  <span className="d-flex align-items-center">
                    <span className="flex-grow-1">Update Mailing SPH</span>
                    {loading && (
                      <Spinner size="sm" className="ms-2 flex-shrink-0" role="status">
                        Loading...
                      </Spinner>
                    )}
                  </span>
                </button>
              </div>
            </div>
          </Form>
        </Modal>

        <Modal id="showModalDetail" isOpen={modalDetail} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleDetail}>
            {`View ${detailType}`}
          </ModalHeader>
          {info !== undefined && info !== null && (
            <>
              <PrintDocF4 innerRef={printRef} item={info} type={detailType} />
            </>
          )}

          <div className="modal-footer">
            <div className="hstack gap-2 justify-content-end">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => {
                  setModalDetail(false);
                }}>
                TUTUP
              </button>
              {<ButtonPrintF4 innerRef={printRef} title={`${detailType}-${info?.nama ?? ""}`} />}
            </div>
          </div>
        </Modal>

        {/* /// */}
        <Modal id="showModal" isOpen={modalTrans} centered size="xl">
          <ModalHeader className="bg-light p-3" toggle={toggleTrans}>
            {info?.material_name ?? ""}
          </ModalHeader>
          <ModalBody>
            <CardBody>
              <div>
                <Row className="m-0 p-0 pb-3 border border-top-0 border-end-0 border-start-0">
                  <div className="col-sm-10">
                    <Row className="m-0 p-0 ">
                      <div className="fw-semibold  text-start">
                        <input className="search-box w-100 form-control" placeholder="Filter Transaksi" onChange={(e) => searchListTrans(e.target.value)} />
                      </div>
                    </Row>
                  </div>
                  <div className="col-sm-2 text-end">
                    <ExportDoc data={printTransDoc} />
                  </div>
                </Row>
                <SimpleBar style={{ height: "450px" }}>
                  <Table className="table-border text-center table-hover">
                    <thead className="align-middle">
                      <tr className="table-active">
                        <td style={{ width: "20px" }}>
                          <input
                            type="checkbox"
                            className="checkboxDetailAll me-2 form-check-input"
                            checked={expense.every((item) => item.isChecked)}
                            onChange={() => {
                              const allChecked = expense.every((item) => item.isChecked);
                              const updatedData = expense.map((item) => ({
                                ...item,
                                isChecked: !allChecked,
                              }));
                              setExpense(updatedData);
                            }}
                          />
                        </td>
                        <td className="text-center" style={{ width: "100px" }}>
                          No Transaksi
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Tanggal
                        </td>
                        <td className="text-center" style={{ width: "80px" }}>
                          Jenis
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Tag
                        </td>
                        <td className="text-right" style={{ width: "170px" }}>
                          Jumlah
                        </td>
                        <td className="text-center" style={{ width: "200px" }}>
                          Keterangan
                        </td>
                      </tr>
                    </thead>
                    <tbody id="newlink">
                      {(expense || []).map((o, i) => {
                        let type;
                        switch (o.type) {
                          case "CASH IN":
                            type = <span className="badge text-uppercase badge-soft-success">{o.type}</span>;
                            break;
                          case "RECEIVABLE":
                            type = <span className="badge text-uppercase badge-soft-info">{o.type}</span>;
                            break;
                          case "CASH OUT":
                            type = <span className="badge text-uppercase badge-soft-warning">{o.type}</span>;
                            break;
                          case "PAYABLE":
                            type = <span className="badge text-uppercase badge-soft-danger">{o.type}</span>;
                            break;
                          default:
                            type = <span className="badge text-uppercase badge-soft-primary">{o.type}</span>;
                            break;
                        }
                        return (
                          // className={(o.hasPaid || o.paid_amount >= o.amount) ? "bg-soft-success" : o.statusId === 3 ? "bg-soft-danger" : ""}
                          <tr key={i}>
                            <td style={{ verticalAlign: "middle", width: "30px" }}>
                              <div className="hstack gap-2 mt-4 mt-sm-0">
                                <input
                                  type="checkbox"
                                  className="checkboxDetail me-2 form-check-input"
                                  checked={o.isChecked}
                                  onChange={() => {
                                    const updatedData = expense.map((d) => (d.id === o.id ? { ...d, isChecked: !d.isChecked } : d));
                                    setExpense(updatedData);
                                  }}
                                />
                              </div>
                            </td>
                            {/* {(o.hasPaid || o.paid_amount >= o.amount) && <span className="badge text-uppercase badge-soft-success mb-3">LUNAS</span>} */}
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {o.transaction_no}
                              {o.statusId === 4 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-danger">CANCELED</span>
                                </p>
                              )}
                              {o.statusId === 3 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-info">RELEASED</span>
                                </p>
                              )}
                              {o.statusId === 2 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-success">APPROVED</span>
                                </p>
                              )}
                              {o.statusId === 1 && (
                                <p className="mb-1">
                                  <span className="badge text-uppercase badge-soft-warning">DRAFT</span>
                                </p>
                              )}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {handleValidDate(o.transactionat)}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {type}
                            </td>
                            <td className="text-center fs-13" style={{ verticalAlign: "middle" }}>
                              {o?.at_cvl_account?.name || o?.at_legal?.owner || o?.at_cvl_contract?.cvl_contract_cvl_account?.name || (o?.at_purchase?.purchase_detail[0] && o?.at_purchase?.purchase_detail[0]?.cvl_account) || o?.at_tag?.name}
                            </td>
                            <td className="text-center" style={{ verticalAlign: "middle" }}>
                              {currencyFormat(o.amount)}
                            </td>
                            <td className="text-left" style={{ verticalAlign: "middle" }}>
                              {o.description}
                            </td>
                          </tr>
                        );
                      })}

                      {expense.length === 0 && (
                        <tr>
                          <td colSpan="7" className="p-3 text-center">
                            Belum ada realisasi
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </SimpleBar>
                <Row className="m-1 p-2 border border-top-0 border-end-0 border-start-0 bg-light">
                  <div className="col-sm-6 fs-12 text-start">
                    HUTANG:
                    <span className="ms-2 me-5 fs-20 fw-semibold text-end text-danger">
                      {currencyFormat(
                        (expense || [])
                          .filter((el) => el.type === "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                          .map((el) => parseFloat(el.amount || 0))
                          .reduce((prev, curr) => prev + curr, 0)
                      )}
                    </span>
                  </div>
                  <div className="col-sm-6 fs-12 text-end">
                    PEMBAYARAN KAS / BANK :
                    <span className="ms-2 me-5 fs-20 fw-semibold text-end text-success">
                      {currencyFormat(
                        (expense || [])
                          .filter((el) => el.type !== "PAYABLE" && (el.statusId === 1 || el.statusId === 2 || el.statusId === 3))
                          .map((el) => parseFloat(el.amount || 0))
                          .reduce((prev, curr) => prev + curr, 0)
                      )}
                    </span>
                  </div>
                </Row>
              </div>
            </CardBody>
          </ModalBody>
        </Modal>
      </div>
    </>
  );
};

export default withRouter(withTranslation()(Legal));
